import React, { useEffect, useMemo, useRef } from "react";
import { useState } from "react";
import html2canvas from "html2canvas";
import {
  Accordion,
  Button,
  Form,
  InputGroup,
  Modal,
  Row,
  Col,
  ListGroup,
  Overlay,
  Popover,
  CloseButton,
  Collapse,
} from "react-bootstrap";
import { Dialog } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import TimePicker from "react-bootstrap-time-picker";
import LinkedCameraIcon from "@mui/icons-material/LinkedCamera";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import AddBoxIcon from "@mui/icons-material/AddBox";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PlagiarismIcon from "@mui/icons-material/Plagiarism";
import {
  setData,
  setForm,
  setSubChild,
} from "../../../redux/slices/StaffFormsSlices";
import { authorizedRequests } from "../../../axios/axios-config";
import { toastify } from "../../../helperFunctions/toastify";
import SelectComponent from "../../SharedComponents/SelectComponent";
import DeleteModal from "../../SharedComponents/DeleteModal";
import { getMedicalInfo } from "../../../apis/medicalInfo";
import moment from "moment";
import { getEditBy } from "../../../apis/appointment";
import {
  getDotPhrases,
  createDotPhrase,
  deleteDotPhrases,
} from "../../../apis/dotPhrases";
import {
  getpaitentSOAP,
  createpaitentSOAP,
  deletepaitentSOAP,
  updateDotPhrase,
} from "../../../apis/paitentSOAP";
import { requiredFieldValidation } from "../../../helperFunctions/validation";
import { useLayoutEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertFromRaw, convertToRaw } from "draft-js";
import { getDrawtool } from "../../../apis/drawtool";
import FilerobotImageEditor, {
  TABS,
  TOOLS,
} from "@bluesilodev/react-filerobot-image-editor";
import { convertFileToBase64 } from "../../../apis/document";
import {
  uploadSessionFiles,
  updateSessionPhoto,
  deleteSessionFiles,
  createPatientChartTemplate,
  readPatientChartTemplate,
  updatePatientChartTemplate,
  deletePatientChartTemplate,
} from "../../../apis/session";
import { getSessionById, getSessionByPatientId } from "../../../apis/session";
import { getPatientDetailsById } from "../../../apis/patients";
import { base64ToFile, formatDate } from "../../../helperFunctions/utils";
import { missingPopup } from "../../../helperFunctions/missingFieldToast";
import PatientPrescriptionSheet from "./PrescriptionSheet";
import PatientCaseFolder from "../Patient/CaseFolder";
import ModalCamera from "./ModalCamera";
import PatientChartTemplate from "./PatientChartTemplate";
import MedicalCertificate from "./MedicalCertificate";

export const SESSION_CURRENT_STATE = Object.freeze({
  patientMedicalHistory: "Patient Medical History",
  patientSOAP: "Patient SOAP",
  patientConsents: "Patient Consents",
  patientChart: "Patient Chart",
  patientPrescriptionSheet: "Patient Prescription Sheet",
  patientCaseFolder: "Patient Case Folder",
});

const defaultPreview =
  "iVBORw0KGgoAAAANSUhEUgAAB9AAAAcIAQMAAABem8h4AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRF////p8QbyAAAB5NJREFUeJztzzEBAAAIgDDtX9oYHmMJYIe13wF/Whe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual3Uuqh1Ueui1kWti1oXtS5qXdS6qHVR66LWRa2LWhe1Lmpd1LqodVHrotZFrYtaF7Uual10StwHCcaHr3YAAAAASUVORK5CYII=";

function PatientMedicalHistory({
  setCurrentState,
  seddionId,
  saveData,
  setSaveData,
  setSuccessSaveData,
  getEditData,
}) {
  /////////////////Declarations\\\\\\\\\\\\\\\\

  const { patientMedicalHistory, dataId } = useSelector(
    (state) => state.staffForm.sessionForm
  );
  const [localState, setLocalStates] = useState(
    patientMedicalHistory.sideEffects?.length > 0
      ? patientMedicalHistory.sideEffects
      : [
          {
            name: "sunExposure",
            isChecked: false,
            value: null,
          },
          {
            name: "smoking",
            isChecked: false,
            value: "",
          },
          {
            name: "alcohol",
            isChecked: false,
            value: "",
          },
        ]
  );

  useEffect(() => {
    if (
      patientMedicalHistory?.sideEffects &&
      patientMedicalHistory?.sideEffects?.length > 0
    ) {
      setLocalStates(patientMedicalHistory.sideEffects);
    }
  }, [patientMedicalHistory?.sideEffects]);

  const dispatch = useDispatch();

  /////////////////functions\\\\\\\\\\\\\\\\\\\\
  const onFormChange = (name, value) => {
    dispatch(
      setSubChild({
        parent: "sessionForm",
        child: "patientMedicalHistory",
        subChild: name,
        value,
      })
    );
  };
  const onLocalChange = (state, name, value) => {
    var tempArr = [...localState];
    var index = localState.findIndex((o) => o.name === state);
    tempArr[index] = { ...tempArr[index], [name]: value };
    if (name === "isChecked") {
      tempArr[index] = { ...tempArr[index], value: "" };
    }
    setLocalStates([...tempArr]);
  };

  const submitForm = async (e) => {
    e.preventDefault();

    const { result, error } = await authorizedRequests({
      url: "session/updateSession",
      method: "post",
      data: {
        dataId,
        patientMedicalHistory: {
          ...patientMedicalHistory,
          sideEffects: [...localState],
        },
      },
    });
    if (error) {
      toastify(error?.message, "error");
      setSuccessSaveData(false);
      return;
    }
    dispatch(
      setForm({
        parent: "sessionForm",
        child: "patientMedicalHistory",
        value: {
          ...patientMedicalHistory,
          sideEffects: [...localState],
        },
      })
    );
    // localStorage.setItem(
    // 	"session_current_state",
    // 	SESSION_CURRENT_STATE.patientSOAP,
    // );
    // setCurrentState(SESSION_CURRENT_STATE.patientSOAP);
    // toastify("Success", "success");
    getEditData();
    setSuccessSaveData(true);
    return;
  };

  ////////////////////hooks\\\\\\\\\\\\\\\\\\\\
  useEffect(() => {
    if (saveData > 0) {
      submitForm({ preventDefault: () => {} });
    }
  }, [saveData]);

  return (
    <>
      <div className="pb-4 pr-4">
        <div className="content">
          <div className="addEdit pb-4">
            <div className="mb-3 d-flex align-self-center col-10 ms-3">
              <Button
                style={{ width: "150px" }}
                className="addItem ms-auto"
                onClick={setSaveData}
              >
                Save
              </Button>
            </div>
            <div className="row">
              <div>
                <div className="d-flex w-100">
                  <Form.Group className="col-md-5">
                    <Form.Label className="black-label-text">
                      Patient Medical History
                    </Form.Label>
                    <InputGroup className="mb-3">
                      <Form.Control
                        name={"pastMedicalHistory"}
                        as="textarea"
                        rows={6}
                        placeholder="Write..."
                        style={{ resize: "none" }}
                        onChange={(e) => {
                          onFormChange("pastMedicalHistory", e.target.value);
                        }}
                        value={patientMedicalHistory.pastMedicalHistory}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group className="col-md-5 ms-3">
                    <Form.Label className="black-label-text ">
                      Past Cosmetic History
                    </Form.Label>
                    <InputGroup className="mb-3">
                      <Form.Control
                        name={"pastCosmeticHistory"}
                        as="textarea"
                        rows={6}
                        placeholder="Write..."
                        style={{ resize: "none" }}
                        onChange={(e) => {
                          onFormChange("pastCosmeticHistory", e.target.value);
                        }}
                        value={patientMedicalHistory.pastCosmeticHistory}
                      />
                    </InputGroup>
                  </Form.Group>{" "}
                </div>
                <div className="d-flex w-100">
                  <Form.Group className="col-md-5">
                    <Form.Label className="black-label-text ">
                      Past Adverse Cosmetic History
                    </Form.Label>
                    <InputGroup className="mb-3">
                      <Form.Control
                        name={"pastAdverseCosmeticHistory"}
                        as="textarea"
                        rows={6}
                        placeholder="Write..."
                        style={{ resize: "none" }}
                        onChange={(e) => {
                          onFormChange(
                            "pastAdverseCosmeticHistory",
                            e.target.value
                          );
                        }}
                        value={patientMedicalHistory.pastAdverseCosmeticHistory}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group className="col-md-5 ms-3">
                    <Form.Label className="black-label-text ">
                      Social History
                    </Form.Label>
                    <InputGroup className="mb-3">
                      <Form.Control
                        name={"socialHistory"}
                        as="textarea"
                        rows={6}
                        placeholder="Write..."
                        style={{ resize: "none" }}
                        onChange={(e) => {
                          onFormChange("socialHistory", e.target.value);
                        }}
                        value={patientMedicalHistory.socialHistory}
                      />
                    </InputGroup>
                  </Form.Group>
                </div>
                <div className="col-md-5 mb-3">
                  <input
                    type={"checkbox"}
                    name="sunExposure"
                    checked={
                      localState.find((o) => o.name === "sunExposure")
                        ?.isChecked
                    }
                    onChange={() => {
                      onLocalChange(
                        "sunExposure",
                        "isChecked",
                        !localState.find((o) => o.name === "sunExposure")
                          ?.isChecked
                      );
                    }}
                  />
                  <span for="sunExposure" className="ms-2 font-400-20">
                    Sun Exposure
                  </span>
                  {localState.find((o) => o.name === "sunExposure")
                    ?.isChecked && (
                    <Form.Group>
                      <InputGroup className="mt-3">
                        <Form.Control
                          name={"sunExposure"}
                          placeholder="Write..."
                          onChange={(e) => {
                            onLocalChange(
                              "sunExposure",
                              "value",
                              e.target.value
                            );
                          }}
                          value={
                            localState.find((o) => o.name === "sunExposure")
                              .value
                          }
                        />
                      </InputGroup>
                    </Form.Group>
                  )}
                </div>
                <div className="col-md-5 mb-3">
                  <input
                    type={"checkbox"}
                    name="smoking"
                    checked={
                      localState.find((o) => o.name === "smoking")?.isChecked
                    }
                    onChange={() => {
                      onLocalChange(
                        "smoking",
                        "isChecked",
                        !localState.find((o) => o.name === "smoking")?.isChecked
                      );
                    }}
                  />

                  <span className="ms-2 font-400-20">Smoking</span>
                  {localState.find((o) => o.name === "smoking")?.isChecked && (
                    <Form.Group>
                      <InputGroup className="mt-3">
                        <Form.Control
                          name={"smoking"}
                          placeholder="Write..."
                          onChange={(e) => {
                            onLocalChange("smoking", "value", e.target.value);
                          }}
                          value={
                            localState.find((o) => o.name === "smoking").value
                          }
                        />
                      </InputGroup>
                    </Form.Group>
                  )}
                </div>
                <div className="col-md-5 mb-3">
                  <input
                    type={"checkbox"}
                    name="alcohol"
                    checked={
                      localState.find((o) => o.name === "alcohol")?.isChecked
                    }
                    // value={localState.find((o) => o.name === "alcohol").isChecked}
                    onChange={() => {
                      onLocalChange(
                        "alcohol",
                        "isChecked",
                        !localState.find((o) => o.name === "alcohol")?.isChecked
                      );
                    }}
                  />

                  <span className="ms-2 font-400-20">Alcohol</span>
                  {localState.find((o) => o.name === "alcohol")?.isChecked && (
                    <Form.Group>
                      <InputGroup className="mt-3">
                        <Form.Control
                          name={"alcohol"}
                          placeholder="Write..."
                          onChange={(e) => {
                            onLocalChange("alcohol", "value", e.target.value);
                          }}
                          value={
                            localState.find((o) => o.name === "alcohol").value
                          }
                        />
                      </InputGroup>
                    </Form.Group>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function PatientSOAP({
  setCurrentState,
  saveData,
  setSaveData,
  setSuccessSaveData,
  getEditData,
}) {
  const dispatch = useDispatch();
  const [rows, setRows] = useState({});

  const { patientSOAP, dataId } = useSelector(
    (state) => state.staffForm.sessionForm
  );

  const [phrases, setPhrases] = useState([]);
  const getDotPhrasesList = async () => {
    const response = await getpaitentSOAP();
    if (response?.status !== "Fail") {
      setPhrases(response);
    } else {
      if (response?.message === "No data Found") {
        setPhrases([]);
      } else {
        toastify(response?.message, "error");
      }
    }
  };

  useEffect(() => {
    getDotPhrasesList();
  }, []);

  useEffect(() => {
    const soapRows = {};
    Object.keys(patientSOAP).map((soapKey) => {
      // Adjust rows based on content
      if (patientSOAP[soapKey]) {
        const newRows = Math.max(2, patientSOAP[soapKey].split("\n").length);
        soapRows[soapKey] = newRows;
      }
    });

    setRows(soapRows);
  }, [patientSOAP]);

  const [fields, setFields] = useState([
    {
      name: "Subjective",
      value: "subjective",
      dot: "",
    },
    {
      name: "Objective",
      value: "objective",
      dot: "",
    },
    {
      name: "Assessment",
      value: "assesment",
      dot: "",
    },
    {
      name: "Plan",
      value: "plan",
      dot: "",
    },
    {
      name: "Recommended Treatment",
      value: "recommendedTreatment",
      dot: "",
    },
    {
      name: "Treatment Done",
      value: "treatmentDone",
      dot: "",
    },
  ]);

  const onFormChange = (name, value) => {
    dispatch(
      setSubChild({
        parent: "sessionForm",
        child: "patientSOAP",
        subChild: name,
        value,
      })
    );
  };

  const handleInputChange = (key, value) => {
    onFormChange(key, value);
  };

  const onSubmit = async () => {
    const { result, error } = await authorizedRequests({
      url: "session/updateSession",
      method: "post",
      data: {
        dataId,
        patientSOAP,
      },
    });
    if (error) {
      toastify(error?.message, "error");
      setSuccessSaveData(false);
      return;
    }

    // toastify("Success", "success");
    setSuccessSaveData(true);
  };
  const [show, setShow] = useState(false);
  const [templateValue, setTemplateValue] = useState();
  const [addPhrase, setAddPhrase] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setAddPhrase(false);
    setShow(true);
  };

  const [phrase, setPhrase] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [title, setTitle] = useState("");
  const [templateId, settemplateId] = useState("");
  const [description, setDescription] = useState();
  const savePhrase = async () => {
    if (!title) {
      missingPopup("Title");
    } else if (!description) {
      missingPopup("Description");
    } else {
      let _data = { template_type: phrase, title, description };

      let response = null;
      if (isEdit) {
        response = await updateDotPhrase(templateId, _data);
      } else {
        response = await createpaitentSOAP(_data);
      }
      if (response?.status !== "Fail") {
        toastify("Template added successfully!", "success");
        getDotPhrasesList();
        setTitle("");
        setDescription("");
        setAddPhrase(false);
        getEditData();
      } else {
        toastify(response?.message, "error");
      }
    }
  };

  const handleEdit = async (id) => {
    setIsEdit(true);
    settemplateId(id?._id);
    setTitle(id?.title);
    setDescription(id?.description);
    setAddPhrase(true);
  };

  const handleDelte = async (id) => {
    const response = await deletepaitentSOAP({ id: id });
    if (response?.status !== "Fail") {
      toastify("Dot Phrase deletd successfully!", "success");
      getDotPhrasesList();
      setTitle("");
      setDescription("");
      setAddPhrase(false);
    } else {
      toastify(response?.message, "error");
    }
  };

  useEffect(() => {
    if (saveData > 0) {
      onSubmit();
    }
  }, [saveData]);

  return (
    <>
      <div className="pr-4 pb-4">
        <div className="addEdit">
          <Button
            className="addItem ms-auto mb-3"
            style={{ width: "150px" }}
            onClick={() => {
              setSaveData();
            }}
          >
            Save
          </Button>
          {fields.map((o) => {
            const currentRows = rows[o.value] || 2;
            return (
              <>
                <Accordion defaultActiveKey={["0"]} alwaysOpen className="mb-2">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className="session-accordion-header">
                      {o.name}
                      <PlagiarismIcon
                        sx={{ ml: 2 }}
                        onClick={(event) => {
                          event.stopPropagation();
                          setTemplateValue(o);
                          setPhrase(o?.value);
                          handleShow();
                        }}
                      />
                    </Accordion.Header>
                    <Accordion.Body>
                      <Form.Group className="col-md-12 ">
                        <InputGroup className="mb-3">
                          <Form.Control
                            name={o.value}
                            as="textarea"
                            rows={currentRows}
                            placeholder="Write..."
                            style={{ resize: "none" }}
                            onChange={(e) => {
                              handleInputChange(o.value, e.target.value);
                            }}
                            value={patientSOAP?.[o.value]}
                          />
                        </InputGroup>
                      </Form.Group>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </>
            );
          })}
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            Templates{" "}
            {!addPhrase && (
              <AddBoxIcon
                sx={{ ml: 2, cursor: "pointer" }}
                onClick={() => {
                  setTitle("");
                  setDescription("");
                  settemplateId("");
                  setIsEdit(false);
                  setAddPhrase(true);
                }}
              />
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!addPhrase ? (
            phrases
              ?.filter((a) => a?.template_type == phrase)
              .map((e, index) => (
                <ListGroup.Item
                  key={index}
                  as="li"
                  className="d-flex justify-content-between align-items-center mb-2 border rounded"
                >
                  <div
                    className="ms-2 me-auto cursor-pointer p-2 w-full"
                    onClick={() => {
                      let descriptionValue = "";
                      const selectedValue = e.description;
                      const updatedFields = fields.map((field) => {
                        if (field.value === templateValue?.value) {
                          if (
                            !patientSOAP[field.value] ||
                            patientSOAP[field.value] === ""
                          ) {
                            descriptionValue = `${selectedValue}`;
                          } else {
                            descriptionValue = `${
                              patientSOAP[field.value]
                            } \n ${selectedValue}`;
                          }
                          return { ...field, dot: descriptionValue };
                        }
                        return field;
                      });
                      setFields(updatedFields);
                      onFormChange(templateValue?.value, descriptionValue);
                      handleClose();
                    }}
                  >
                    <div className="fw-bold">{e.title}</div>
                  </div>
                  <EditIcon
                    sx={{ cursor: "pointer", marginRight: "10px" }}
                    onClick={(el) => {
                      handleEdit(e);
                    }}
                  />
                  <CloseIcon
                    sx={{ cursor: "pointer", marginRight: "10px" }}
                    onClick={(el) => {
                      handleDelte(e?._id);
                    }}
                  />
                </ListGroup.Item>
              ))
          ) : (
            <>
              <Form.Group>
                <div className="h5">Template Title *</div>
                <InputGroup className="mb-3">
                  <Form.Control
                    placeholder="Write..."
                    onChange={(e) => {
                      setTitle(e.target.value);
                    }}
                    value={title}
                  />
                </InputGroup>
              </Form.Group>
              <Form.Group>
                <div className="h5">Description *</div>
                <InputGroup>
                  <Form.Control
                    as="textarea"
                    style={{ resize: "none" }}
                    rows={6}
                    placeholder="Write..."
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                  />
                </InputGroup>
              </Form.Group>
            </>
          )}

          {/* <select
            className="form-select mb-3"
            defaultValue={templateValue?.dot}
            placeholder="Select Template"
            value={templateValue?.dot}
            onChange={(e) => {
              const selectedValue = e.target.value;
              const updatedFields = fields.map((field) => {
                if (field.value === templateValue?.value) {
                  return { ...field, dot: selectedValue };
                }
                return field;
              });
              setFields(updatedFields);
              onFormChange(templateValue?.value, e.target.value);
              handleClose();
            }}
          >
            <option value="">Select Template</option>
            {phrases?.map((e) => (
              <option value={e.description}>{e.title}</option>
            ))}
          </select> */}
        </Modal.Body>
        {addPhrase && (
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setAddPhrase(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={() => savePhrase()}>
              Save Template
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}

function PatientConsents({ setCurrentState, getEditData }) {
  const dispatch = useDispatch();

  const { sessionForm } = useSelector((state) => state.staffForm);
  const [consents, setConsents] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [consentToSign, setConsentToSign] = useState();
  const [patientRef, setPatientRef] = useState({});
  const [doctorRef, setDoctorRef] = useState({});

  const [allConsents, setAllConsents] = useState([]);
  const [selectedConsents, setSelectedConsents] = useState([]);

  // const [signatures, setSignatures] = useState(
  // 	sessionForm?.patientConsents?.map((o) => {
  // 		return {
  // 			consent: o.consent,
  // 			pateintSign: o.pateintSign || "",
  // 			doctorSign: o.doctorSign || "",
  // 		};
  // 	}) || [],
  // );

  const getSignatures = async () => {
    //Signatures data to be send in API
    var tempArr = consents?.map((sign) => {
      if (sign._id == consentToSign) {
        return {
          consent: sign.value,
          pateintSign: patientRef.toDataURL("image/png"),
          doctorSign: doctorRef.toDataURL("image/png"),
        };
      } else {
        return {
          consent: sign.value,
          pateintSign: sign.pateintSign,
          doctorSign: sign.doctorSign,
        };
      }
    });

    //signatures to be displayed alongwith their title
    const tempConsentsArr = consents?.map((sign) => {
      if (sign._id == consentToSign) {
        return {
          ...sign,
          pateintSign: patientRef.toDataURL("image/png"),
          doctorSign: doctorRef.toDataURL("image/png"),
        };
      } else {
        return {
          ...sign,
        };
      }
    });
    setConsents(tempConsentsArr);

    const { result, error } = await authorizedRequests({
      url: "session/updateSession",
      method: "post",
      data: {
        dataId: sessionForm.dataId,
        patientConsents: [...tempArr],
      },
    });
    if (error) {
      toastify(error?.message ?? "Unknown error occured", "error");
      return;
    }
    getEditData();
    toastify("Signatures saved succesfully", "success");
    setModalShow(false);
  };

  useMemo(() => {
    if (sessionForm.dataId) {
      (async () => {
        const { result, error } = await getSessionById(sessionForm.dataId);
        if (error) {
          toastify("Failed to get session consents", "error");
          return;
        }
        const tempConsentsArr = [];
        const tempSelectedConsents = [];
        result.data.patientConsents?.forEach((o) => {
          tempSelectedConsents.push(o?.consent?._id);
          tempConsentsArr.push({
            ...o.consent,
            label: o.consent.title,
            value: o.consent._id,
            pateintSign: o.pateintSign,
            doctorSign: o.doctorSign,
          });
        });
        setConsents(tempConsentsArr);
        setSelectedConsents(tempSelectedConsents);
      })();
    }
  }, [sessionForm.dataId]);

  useEffect(() => {
    (async () => {
      const { result, error } = await authorizedRequests({
        url: "consents/listOfConsents",
        method: "get",
      });
      if (error) {
        toastify(error.message ?? "Can't get consents list", "error");
        return;
      }

      const tempArr = result?.data?.map((o) => {
        return {
          ...o,
          label: o.title,
          value: o._id,
          patientSign: "",
          doctorSign: "",
        };
      });
      setAllConsents(tempArr);
    })();
  }, []);

  return (
    <>
      <div className="consent-container pr-4 pb-4">
        <div className="addEdit">
          <div className="col-5">
            <SelectComponent
              isNullEnabled
              searchEnabled
              options={allConsents}
              onChange={(value) => {
                setSelectedConsents(value);
                const tempArr = allConsents
                  .filter((o) => value.indexOf(o._id) !== -1)
                  ?.map((o) => {
                    const index = consents.findIndex((con) => con._id == o._id);
                    if (index !== -1) {
                      return {
                        ...o,
                        pateintSign: consents[index].pateintSign,
                        doctorSign: consents[index].doctorSign,
                      };
                    }
                    return o;
                  });
                setConsents(tempArr);
              }}
              array={selectedConsents}
            />
          </div>
        </div>
        {consents.length > 0 &&
          consents.map((con) => {
            return (
              <>
                <Accordion className="mb-2">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className="session-accordion-header">
                      {con.title}
                    </Accordion.Header>
                    <Accordion.Body>
                      <p className="mt-0 ">
                        <Editor
                          editorState={EditorState.createWithContent(
                            convertFromRaw(JSON.parse(con.url))
                          )}
                          wrapperClassName="p-0"
                          editorClassName=" hidePointer"
                          disabled
                          toolbarHidden={true}
                          wrapperStyle={{
                            overflow: "hidden",
                            padding: "30px 0px",
                            marginBottom: "30px",
                          }}
                        />
                      </p>
                      <div className="w-100">
                        <Button
                          className="addItem ms-auto"
                          onClick={() => {
                            setModalShow(true);
                            setConsentToSign(con._id);
                          }}
                        >
                          Sign Here
                        </Button>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </>
            );
          })}
        <Modal
          centered
          show={modalShow}
          onHide={() => {
            setConsentToSign(null);
            setModalShow(!modalShow);
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <div className="w-100 text-center">Add Signatures</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div
                className="patient-signature"
                style={{
                  background: "#F8F8F8",
                  borderRadius: " 12px",
                }}
              >
                <div
                  className="text-center p-3 grey font-400-20"
                  style={{
                    borderBottom: "2px solid #E9E9E9",
                  }}
                >
                  Patient's Signature
                </div>
                <SignatureCanvas
                  penColor="green"
                  ref={(ref) => {
                    ref?.fromDataURL(
                      consents.find((o) => o._id === consentToSign)?.pateintSign
                    );

                    setPatientRef(ref);
                  }}
                  canvasProps={{
                    style: {
                      width: "100%",
                      height: "30vh",
                    },
                    className: "sigCanvas",
                  }}
                />
              </div>
              <Button
                className="grey-rounded-button ms-auto mt-3"
                onClick={() => {
                  patientRef.clear();
                }}
              >
                Clear Box
              </Button>
              <div
                className="doctor-signature"
                style={{
                  background: "#F8F8F8",
                  borderRadius: " 12px",
                }}
              >
                <div
                  className="text-center mt-3 p-3 grey font-400-20"
                  style={{
                    borderBottom: "2px solid #E9E9E9",
                  }}
                >
                  Doctor's Signature
                </div>
                <SignatureCanvas
                  penColor="green"
                  ref={(ref) => {
                    ref?.fromDataURL(
                      consents.find((o) => o._id === consentToSign)?.doctorSign
                    );

                    setDoctorRef(ref);
                  }}
                  canvasProps={{
                    style: {
                      width: "100%",
                      height: "30vh",
                    },
                    className: "sigCanvas",
                  }}
                />
              </div>
              <Button
                className="grey-rounded-button ms-auto mt-3"
                onClick={() => {
                  doctorRef.clear();
                }}
              >
                Clear Box
              </Button>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="addItem"
              // variant="addItem"
              onClick={getSignatures}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const XIcon = ({
  color = "currentColor",
  size = 24,
  xIconRef: iconRef,
  ...props
}) => (
  <div ref={iconRef} className="d-flex justify-content-center">
    <svg
      width={size}
      height={size}
      viewBox="0 0 384 512"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--> */}
      <path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z" />
    </svg>
    {/*
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.36 5.64a1.5 1.5 0 0 0-2.12 0L12 8.88 7.76 4.64a1.5 1.5 0 0 0-2.12 2.12L9.88 12 5.64 16.24a1.5 1.5 0 0 0 2.12 2.12L12 13.12l4.24 4.24a1.5 1.5 0 0 0 2.12-2.12L14.12 12l4.24-4.24a1.5 1.5 0 0 0 0-2.12z"
      />
    </svg>
    */}
  </div>
);

const XIconRefEL = ({
  color = "currentColor",
  size = 24,
  xIconRef: iconRef,
  ...props
}) => (
  <div ref={iconRef} className="d-flex justify-content-center" {...props}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 384 512"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z" />
    </svg>
  </div>
);

function TooltipComponent({
  message,
  xIconRef,
  show,
  setShowTooltip,
  resetSelectFirstChart,
  target,
  currentColor,
  setCurrentColor,
  addElementAnnotation,
  enableClick,
  setEnableClick,
  isBodyVisible,
  setIsBodyVisible,
  setStateIconRef,
  placement,
}) {
  const [getColor, setGetColor] = useState(
    JSON.parse(localStorage.getItem("patientChartColor")) || []
  );
  const saveColor = () => {
    const finalColor = [...getColor];
    finalColor.push(currentColor || "#000000");
    setGetColor(finalColor);
    localStorage.setItem("patientChartColor", JSON.stringify(finalColor));
  };
  const deleteColor = (deleteColor) => {
    const finalColor = getColor.filter((color) => color !== deleteColor);
    setGetColor(finalColor);
    localStorage.setItem("patientChartColor", JSON.stringify(finalColor));
  };

  useEffect(() => {
    if (show) {
      const elCheck = document.getElementById("xiconcheck");
      if (elCheck && !elCheck.checked) {
        elCheck.click();
      }
    }
  }, [show]);

  return (
    <Overlay
      target={target}
      show={show}
      placement={placement === "top" ? "top" : "bottom"}
    >
      <Popover
        id="popover-basic"
        style={{ width: "240px" }}
        className="popover-filerobot"
      >
        <Popover.Header
          as="div"
          onClick={() => {
            // setIsBodyVisible(!isBodyVisible);
            // if (!isBodyVisible) {
            //   setTimeout(() => {
            //     window.scrollTo({
            //       top: document.body.scrollHeight, // Scroll to the height of the document
            //       behavior: 'smooth' // Smooth scrolling
            //     });
            //   }, 500);
            // } else {
            //   setTimeout(() => {
            //     window.scrollTo({
            //       top: document.body.scrollHeight - 10, // Adjust this value to control how far up to scroll
            //       behavior: 'smooth' // Smooth scrolling
            //     });
            //   }, 500);
            // }
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5 className="m-0">X Icon</h5>
            <Button
              variant="none"
              onClick={(e) => {
                e.preventDefault();
                setShowTooltip(false);
                setEnableClick(false);
                setIsBodyVisible(true);
                resetSelectFirstChart();
              }}
              style={{ padding: 0, width: "26px", fontSize: "20px", border: 0 }}
            >
              &times;
            </Button>
          </div>
        </Popover.Header>
        <div>
          <Popover.Body>
            <Row>
              <Col xs="auto">Choose Your Color</Col>
              <Col xs="auto">
                <input
                  type="color"
                  value={currentColor}
                  onInput={(e) => setCurrentColor(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="py-2">
              <Col xs="auto">Saved Color</Col>
            </Row>
            <Row xs={4} className="w-full g-2 py-2">
              {getColor.map((color) => {
                return (
                  <Col>
                    <div
                      style={{
                        position: "relative",
                        width: "45px",
                        height: "30px",
                        backgroundColor: color,
                        borderRadius: "10px",
                        cursor: "pointer",
                      }}
                      className="d-flex align-items-center justify-content-center"
                      onClick={() => setCurrentColor(color)}
                    >
                      <span
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          position: "absolute",
                          right: "6px",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => deleteColor(color)}
                      >
                        X
                      </span>
                    </div>
                  </Col>
                );
              })}
            </Row>
            <Row className="py-2">
              <Col className="text-center fw-bold">Preview</Col>
            </Row>
            <Row className="py-2">
              <Col xs className="font-xl justify-content-center">
                <XIcon color={currentColor} size={50} />
                <XIconRefEL
                  color={currentColor}
                  size={200}
                  xIconRef={xIconRef}
                  style={{ position: "absolute", top: "-999999px" }}
                />
              </Col>
            </Row>
            <Row className="py-2">
              <Col xs>
                <Form.Check
                  id="xiconcheck"
                  label="Enable X Icon on click"
                  checked={enableClick}
                  onChange={(e) => setEnableClick(e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs>
                <Button className="w-full" onClick={saveColor}>
                  Bookmark
                </Button>
              </Col>
              {/* <Col xs>
                  <Button className="w-full" onClick={addElementAnnotation}>Save</Button>
                </Col> */}
            </Row>
          </Popover.Body>
        </div>
      </Popover>
    </Overlay>
  );
}

function TooltipComponentTemplate({
  message,
  xIconRef,
  show,
  setShowTooltip,
  resetSelectSecondChart,
  target,
  currentColor,
  setCurrentColor,
  addElementAnnotation,
  enableClick,
  setEnableClick,
  isBodyVisible,
  setIsBodyVisible,
  setStateIconRef,
  placement,
}) {
  const [getColor, setGetColor] = useState(
    JSON.parse(localStorage.getItem("patientChartColor")) || []
  );
  const saveColor = () => {
    const finalColor = [...getColor];
    finalColor.push(currentColor || "#000000");
    setGetColor(finalColor);
    localStorage.setItem("patientChartColor", JSON.stringify(finalColor));
  };
  const deleteColor = (deleteColor) => {
    const finalColor = getColor.filter((color) => color !== deleteColor);
    setGetColor(finalColor);
    localStorage.setItem("patientChartColor", JSON.stringify(finalColor));
  };

  useEffect(() => {
    if (show) {
      const elCheck = document.getElementById("xiconcheck");
      if (elCheck && !elCheck.checked) {
        elCheck.click();
      }
    }
  }, [show]);

  return (
    <Overlay
      target={target}
      show={show}
      placement={placement === "top" ? "left-start" : "bottom"}
    >
      <Popover
        id="popover-basic"
        style={{ width: "240px" }}
        className="popover-filerobot"
      >
        <Popover.Header
          as="div"
          onClick={() => {
            // setIsBodyVisible(!isBodyVisible);
            // if (!isBodyVisible) {
            //   setTimeout(() => {
            //     window.scrollTo({
            //       top: document.body.scrollHeight, // Scroll to the height of the document
            //       behavior: 'smooth' // Smooth scrolling
            //     });
            //   }, 500);
            // } else {
            //   setTimeout(() => {
            //     window.scrollTo({
            //       top: document.body.scrollHeight - 10, // Adjust this value to control how far up to scroll
            //       behavior: 'smooth' // Smooth scrolling
            //     });
            //   }, 500);
            // }
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h5 className="m-0">X Icon</h5>
            <Button
              variant="none"
              onClick={(e) => {
                e.preventDefault();
                setShowTooltip(false);
                setEnableClick(false);
                setIsBodyVisible(true);
                resetSelectSecondChart();
              }}
              style={{ padding: 0, width: "26px", fontSize: "20px", border: 0 }}
            >
              &times;
            </Button>
          </div>
        </Popover.Header>
        <div>
          <Popover.Body>
            <Row>
              <Col xs="auto">Choose Your Color</Col>
              <Col xs="auto">
                <input
                  type="color"
                  value={currentColor}
                  onInput={(e) => setCurrentColor(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="py-2">
              <Col xs="auto">Saved Color</Col>
            </Row>
            <Row xs={4} className="w-full g-2 py-2">
              {getColor.map((color) => {
                return (
                  <Col>
                    <div
                      style={{
                        position: "relative",
                        width: "45px",
                        height: "30px",
                        backgroundColor: color,
                        borderRadius: "10px",
                        cursor: "pointer",
                      }}
                      className="d-flex align-items-center justify-content-center"
                      onClick={() => setCurrentColor(color)}
                    >
                      <span
                        style={{
                          color: "red",
                          fontWeight: "bold",
                          position: "absolute",
                          right: "6px",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => deleteColor(color)}
                      >
                        X
                      </span>
                    </div>
                  </Col>
                );
              })}
            </Row>
            <Row className="py-2">
              <Col className="text-center fw-bold">Preview</Col>
            </Row>
            <Row className="py-2">
              <Col xs className="font-xl justify-content-center">
                <XIcon color={currentColor} size={50} />
                <XIconRefEL
                  color={currentColor}
                  size={200}
                  xIconRef={xIconRef}
                  style={{ position: "absolute", top: "-999999px" }}
                />
              </Col>
            </Row>
            <Row className="py-2">
              <Col xs>
                <Form.Check
                  id="xiconcheck"
                  label="Enable X Icon on click"
                  checked={enableClick}
                  onChange={(e) => setEnableClick(e.target.checked)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs>
                <Button className="w-full" onClick={saveColor}>
                  Bookmark
                </Button>
              </Col>
              {/* <Col xs>
                  <Button className="w-full" onClick={addElementAnnotation}>Save</Button>
                </Col> */}
            </Row>
          </Popover.Body>
        </div>
      </Popover>
    </Overlay>
  );
}

function PatientChart({ setCurrentState, disabled, seddionId, getEditData }) {
  const { sessionForm } = useSelector((state) => state.staffForm);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isFullScreenTemplate, setIsFullScreenTemplate] = useState(false);
  const [markers, setMarkers] = useState([]);
  const [faces, setFaces] = useState([]);
  const [selectedFace, setSelectedFace] = useState();
  const [selectedFaceId, setSelectedFaceId] = useState(null);
  const [selectedFaceIdUnique, setSelectedFaceIdUnique] = useState(null);
  const navigate = useNavigate();
  const [captions, setCaptions] = useState([]);
  const [text, setText] = useState("");
  const [tab, setTab] = useState("");
  const [preview, setPreview] = useState();
  const [sessionData, setsessionData] = useState();
  const [isPrevious, setisPrevious] = useState(false);
  const [draftChart, setDraftChart] = useState({});
  const [draftChartTemplate, setDraftChartTemplate] = useState({});
  const [finalDraftChart, setFinalDraftChart] = useState({});
  const [finalDraftChartTemplate, setFinalDraftChartTemplate] = useState({});
  const [isSpaceHeld, setIsSpaceHeld] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltipTemplate, setShowTooltipTemplate] = useState(false);
  const [tooltipTarget, setTooltipTarget] = useState(null);
  const [tooltipTargetTemplate, setTooltipTargetTemplate] = useState(null);
  const [currentColor, setCurrentColor] = useState();
  const [enableClick, setEnableClick] = useState(false);
  const [designLayerClip, setDesignLayerClip] = useState({
    x: undefined,
    y: undefined,
    tries: undefined,
  });
  const editorRef = useRef(null);
  const editorRefTemplate = useRef(null);
  const imageGetRef = useRef();
  const imageGetTemplateRef = useRef();
  const imageUpRef = useRef();
  const imageUpTemplateRef = useRef();
  const iconRef = useRef();
  const [stateIconRef, setStateIconRef] = useState();
  const [isBodyVisible, setIsBodyVisible] = useState(true);
  const [patientChartId, setPatientChartId] = useState(null);
  const [isBodyVisibleTemplate, setIsBodyVisibleTemplate] = useState(true);
  const [isCtrlPressed, setIsCtrlPressed] = useState(false);

  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [templateValue, setTemplateValue] = useState();
  const [addTemplate, setAddTemplate] = useState(false);

  const handleClose = () => {
    if (addTemplate === true) {
      setFinalDraftChartTemplate({});
      setTimeout(() => {
        setDraftChartTemplate({});
        setPatientChartId(null);
        setTitle("");
        setAddTemplate(false);
        setIsEdit(false);
      }, 1000);
    } else {
      setFinalDraftChartTemplate({});
      setTimeout(() => {
        setShow(false);
        setDraftChartTemplate({});
        setPatientChartId(null);
        setIsEdit(false);
        setTitle("");
      }, 1000);
    }
  };
  const handleShow = () => {
    setAddTemplate(false);
    setShow(true);
  };

  const [isEdit, setIsEdit] = useState(false);
  const [title, setTitle] = useState("");
  const [templateData, setTemplateData] = useState([]);

  useEffect(() => {
    if (iconRef.current) {
      setStateIconRef(iconRef.current);
    }
  }, [iconRef.current]);

  useEffect(() => {
    populateSessionData();
    populateTemplateData();
  }, []);

  useEffect(() => {
    if (!showTooltip && enableClick) {
      setShowTooltip(true);
    }
  }, [showTooltip]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey) {
        setIsCtrlPressed(true);
      }
    };

    const handleKeyUp = (event) => {
      if (!event.ctrlKey) {
        setIsCtrlPressed(false);
      }
    };

    // Add event listeners
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    // Cleanup event listeners
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  useEffect(() => {
    if (!enableClick) return;

    const handleClick = (event) => {
      const target = event.target;

      if (
        (target.closest(".FIE_carousel-item > div") &&
          !target.closest(".CUSTOM-X-ICON")) ||
        target.closest(".FIE_topbar-save-button") ||
        target.closest(".button-fullscreen")
      ) {
        setShowTooltip(false);
        setEnableClick(false);
        setIsBodyVisible(true);
        setShowTooltipTemplate(false);
        setIsBodyVisibleTemplate(true);
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [enableClick]);

  useEffect(() => {
    if (isCtrlPressed) {
      document
        .querySelector(".FIE_custom .FIE_canvas-node")
        ?.classList?.remove("force-default-cursor");
      document
        .querySelector(".FIE_custom .FIE_canvas-node")
        ?.classList?.add("force-default-grab");
      document
        .querySelector(".FIE_modal_custom .FIE_canvas-node")
        ?.classList?.remove("force-default-cursor");
      document
        .querySelector(".FIE_modal_custom .FIE_canvas-node")
        ?.classList?.add("force-default-grab");
    } else if (enableClick) {
      document
        .querySelector(".FIE_custom .FIE_canvas-node")
        ?.classList?.remove("force-default-grab");
      document
        .querySelector(".FIE_custom .FIE_canvas-node")
        ?.classList?.add("force-default-cursor");
      document
        .querySelector(".FIE_modal_custom .FIE_canvas-node")
        ?.classList?.remove("force-default-grab");
      document
        .querySelector(".FIE_modal_custom .FIE_canvas-node")
        ?.classList?.add("force-default-cursor");
    } else {
      document
        .querySelector(".FIE_custom .FIE_canvas-node")
        ?.classList?.remove("force-default-grab");
      document
        .querySelector(".FIE_custom .FIE_canvas-node")
        ?.classList?.remove("force-default-cursor");
      document
        .querySelector(".FIE_modal_custom .FIE_canvas-node")
        ?.classList?.remove("force-default-grab");
      document
        .querySelector(".FIE_modal_custom .FIE_canvas-node")
        ?.classList?.remove("force-default-cursor");
    }
  }, [enableClick, isCtrlPressed]);

  const resetSelectFirstChart = () => {
    let elFirstChart = document.querySelector(
      ".first-patient-chart .FIE_polygon-tool-button"
    );
    if (elFirstChart) {
      elFirstChart.click();
    }
  };

  const resetSelectSecondChart = () => {
    let elFirstChart = document.querySelector(
      ".first-patient-chart .FIE_polygon-tool-button"
    );
    if (elFirstChart) {
      elFirstChart.click();
    }
  };

  const resetTotal = () => {
    setEnableClick(false);
    setShowTooltip(false);
    setIsBodyVisible(true);
    resetSelectFirstChart();
    // document.querySelector("first-patient-chart ")
  };

  const populateTemplateData = () => {
    readPatientChartTemplate().then((res) => {
      setTemplateData(res);
    });
  };

  const removePatientChart = async () => {
    const { result, error } = await deleteSessionFiles({
      dataId: patientChartId?.sessionId,
      patientChartId: patientChartId?.chartId,
    });
    if (error) {
      toastify(error.message ?? "Failed to delete patient chart", "error");
      return;
    }

    setPatientChartId(null);
    if (faces?.length > 0) {
      changeFace(faces[0]);
    }
    const updatedSessionData = [];
    sessionData.map((arrChart) => {
      updatedSessionData.push(
        arrChart.filter((x) => x._id !== patientChartId?.chartId)
      );
    });
    setsessionData(updatedSessionData);
    toastify("Patient Chart Deleted succesfully", "success");
    setShowConfirmation(false);
  };

  const populateSessionData = () => {
    getSessionByPatientId(sessionForm?.patientID).then((res) => {
      setsessionData(() => {
        const data = res.result?.data?.map((e) => {
          return e.patientChart.map((prescription) => {
            return { ...prescription, date: e.date, sessionId: e._id };
          });
        });
        data.forEach((subArray) => {
          if (subArray.length > 0) {
            subArray.sort((a, b) => {
              let dateA = new Date(a.date);
              let dateB = new Date(b.date);
              return dateB - dateA;
            });
          }
        });
        data.sort((a, b) => {
          if (a.length === 0) return 1;
          if (b.length === 0) return -1;
          let dateA = new Date(a[0].date);
          let dateB = new Date(b[0].date);
          return dateB - dateA;
        });
        return data;
      });
    });
  };

  const updateDesignLayer = () => {
    const getCurrentContainerRef = imageGetRef.current();
    if (getCurrentContainerRef) {
      const { width, height } =
        getCurrentContainerRef.designState.shownImageDimensions;
      if (width !== designLayerClip.x && height !== designLayerClip.y) {
        setDesignLayerClip({ x: width, y: height, tries: 0 });
      } else {
        setTimeout(updateDesignLayer, 3000);
      }
    }
  };

  const changeFace = async (e) => {
    // updateDesignLayer();
    resetTotal();

    setMarkers([]);
    setCaptions([]);
    setisPrevious(false);

    const getImage = await convertFileToBase64({ url: e.imageUrl });
    const preview = getImage.data;
    let faceData = {};
    if (!draftChart[e._id]) {
      faceData = {
        [e._id]: {
          preview: preview,
          jsonChart: null,
          template: e,
        },
      };
    } else {
      faceData = {
        [e._id]: {
          preview: preview,
          jsonChart: JSON.parse(JSON.stringify(draftChart[e._id])),
          template: e,
        },
      };
    }

    setFinalDraftChart({
      ...finalDraftChart,
      ...faceData,
    });

    setSelectedFaceId(e._id);
    setSelectedFaceIdUnique(e._id);

    const container = document.getElementsByClassName("FIE_tabs");
    if (container.length > 0) {
      container[0].children[2].children[0].innerHTML = `
        <svg height="50" width="50" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
          <path d="M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"></path>
        </svg>
      `;
      container[0].children[2]
        .querySelector("label")
        .querySelector("span").innerHTML = "Drag";
    }
  };

  const addElementAnnotation = async (x, y) => {
    !x && !y && handleShowHideTooltip();
    let imageIconURL;

    if (stateIconRef) {
      const canvas = await html2canvas(stateIconRef, { backgroundColor: null });
      const imgData = canvas.toDataURL("image/png");
      imageIconURL = imgData;
    }
    const time = `Image-${new Date().getTime()}`;
    const image = await new Promise((resolve, reject) => {
      const image = new Image();
      image.src = `data:application/image;base64,${finalDraftChart?.[selectedFaceId]?.preview}`;
      image.onload = function () {
        resolve({
          width: image.width,
          height: image.height,
        });
        image.onerror = function () {
          resolve({
            width: 0,
            height: 0,
          });
        };
      };
    });
    /*
    const finalX = x && designLayerClip.x ? ((designLayerClip.x * parseFloat(x) / 100) - 15) : image.width / 2;
    const finalY = y && designLayerClip.y ? ((designLayerClip.y * parseFloat(y) / 100) - 15) : image.height / 4;
    */
    const getCurrentContainerRef = imageGetRef.current();
    if (!getCurrentContainerRef) {
      return;
    }
    const { width, height } =
      getCurrentContainerRef.designState.shownImageDimensions;
    const finalX =
      x && width ? (width * parseFloat(x)) / 100 - 15 : image.width / 2;
    const finalY =
      y && height ? (height * parseFloat(y)) / 100 - 15 : image.height / 4;
    const annotation = {
      [time]: {
        fill: undefined,
        stroke: "#000000",
        strokeWidth: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowBlur: 0,
        shadowColor: "#000000",
        shadowOpacity: 1,
        opacity: 1,
        disableUpload: true,
        gallery: [
          {
            originalUrl: imageIconURL,
            previewUrl: imageIconURL,
          },
        ],
        name: "Image",
        image: imageIconURL,
        x: finalX,
        y: finalY,
        width: 30,
        height: 30,
        id: time,
      },
    };
    const annotationReturn = {
      id: time,
      fill: undefined,
      stroke: "#000000",
      strokeWidth: 0,
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      shadowBlur: 0,
      shadowColor: "#000000",
      shadowOpacity: 1,
      opacity: 1,
      disableUpload: true,
      gallery: [
        {
          originalUrl: imageIconURL,
          previewUrl: imageIconURL,
        },
      ],
      name: "Image",
      image: imageIconURL,
      x: finalX,
      y: finalY,
      width: 30,
      height: 30,
      id: time,
    };
    return annotationReturn;
    /*
    setFinalDraftChart((oldValue) => {
      return {
        ...draftChart,
        [selectedFaceId]: {
          preview: finalDraftChart?.[selectedFaceId]?.preview,
          jsonChart: {
            ...draftChart[selectedFaceId],
            annotations: {
              ...(draftChart[selectedFaceId]?.annotations || {}),
              ...annotation,
            },
            imgSrc: `data:application/image;base64,${finalDraftChart?.[selectedFaceId]?.preview}`,
          },
        },
      };
    });
    setDraftChart((oldValue) => {
      return {
        ...oldValue,
        [selectedFaceId]: {
          ...oldValue[selectedFaceId],
          annotations: {
            ...(oldValue[selectedFaceId]?.annotations || {}),
            ...annotation,
          },
          imgSrc: `data:application/image;base64,${finalDraftChart?.[selectedFaceId]?.preview}`,
        },
      };
    });
    */
  };

  const handleShowHideTooltip = (event) => {
    const elFIE_tabs = document.querySelector(".FIE_tabs .FIE_tab:last-child");
    event && setTooltipTarget(elFIE_tabs ? elFIE_tabs : event.currentTarget);
    setShowTooltip((val) => !val);
    if (!showTooltip === false) {
      resetSelectFirstChart();
    } else {
      const elCanvas = document.querySelector(
        ".first-patient-chart .FIE_canvas-node"
      );
      if (elCanvas) {
        elCanvas.style.setProperty("cursor", "default", "important");
      }
    }
    // setEnableClick(true);
    setIsBodyVisible(true);
  };

  const handleShowHideTooltipTemplate = (event) => {
    event && setTooltipTargetTemplate(event.currentTarget);
    setShowTooltipTemplate((val) => !val);
    if (!showTooltipTemplate === false) {
      resetSelectSecondChart();
    } else {
      const elCanvas = document.querySelector(
        ".second-patient-chart .FIE_canvas-node"
      );
      if (elCanvas) {
        elCanvas.style.setProperty("cursor", "default", "important");
      }
    }
    // setEnableClick(true);
    setIsBodyVisible(true);
  };

  useEffect(() => {
    const container = document.getElementsByClassName("FIE_tabs");
    const tab = document.getElementsByClassName("FIE_tools-bar-wrapper");
    if (container.length > 0) {
      container[0].children[2].children[0].innerHTML = `
        <svg height="50" width="50" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
          <path d="M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"></path>
        </svg>
      `;
      container[0].children[2]
        .querySelector("label")
        .querySelector("span").innerHTML = "Drag";
    }
    if (tab.length > 0) {
      if (tab[0].querySelector(".CUSTOM-X-ICON")) return;
      const getElementList = tab[0].children[1].children[0].children[0];
      const listItem = document.createElement("li");
      listItem.className = `${getElementList.children[1].className} CUSTOM-X-ICON`;
      const div = document.createElement("div");
      div.className = `${getElementList.children[1].children[0].className}`;
      div.setAttribute("aria-selected", "false");
      div.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.04757 38.9503C0.437373 38.3401 0.437373 37.3508 1.04757 36.7406L33.9229 3.86697L23.8354 3.33584C22.9736 3.29047 22.3118 2.5551 22.3572 1.69335C22.4026 0.831601 23.138 0.169794 23.9997 0.215167L37.5909 0.930759C38.3892 0.972794 39.027 1.61063 39.0691 2.40894L39.7846 16.0001C39.83 16.8619 39.1682 17.5972 38.3065 17.6426C37.4447 17.688 36.7093 17.0262 36.664 16.1644L36.1328 6.07651L3.25728 38.9503C2.64708 39.5605 1.65776 39.5605 1.04757 38.9503Z" fill="currentColor"></path>
        </svg>
      `;
      const label = document.createElement("label");
      label.className = `${getElementList.children[1].children[0].children[1].className}`;
      label.setAttribute("type", "default");
      const span = document.createElement("span");
      span.className = `${getElementList.children[1].children[0].children[1].children[0].className}`;
      span.textContent = "X Icon";
      label.appendChild(span);
      div.appendChild(label);
      listItem.appendChild(div);
      listItem.addEventListener("click", handleShowHideTooltip);
      getElementList.insertBefore(listItem, getElementList.firstChild);
    }
  }, [finalDraftChart]);

  const changeFaceView = async (e) => {
    // updateDesignLayer();
    resetTotal();

    const updatedFinalDraftChart = JSON.parse(JSON.stringify(finalDraftChart));

    if (!draftChart[e._id]) {
      if (e.jsonChart) {
        const templateFace = faces.find((f) => f._id === e.template);
        if (templateFace) {
          const getImage = await convertFileToBase64({
            url: templateFace.imageUrl,
          });
          const jsonChart = JSON.parse(e.jsonChart);
          updatedFinalDraftChart[e._id] = {
            preview: getImage.data,
            jsonChart: jsonChart,
            template: templateFace,
            name: e.name,
          };
        }
      }
    } else {
      const templateFace = faces.find((f) => f._id === e.template);
      if (templateFace) {
        const getImage = await convertFileToBase64({
          url: templateFace.imageUrl,
        });
        updatedFinalDraftChart[e._id] = {
          preview: getImage.data,
          jsonChart: JSON.parse(JSON.stringify(draftChart[e._id])),
          template: templateFace,
          name: e.name,
        };
      }
    }

    setMarkers([]);
    setCaptions([]);
    setisPrevious(true);
    setFinalDraftChart(updatedFinalDraftChart);
    setSelectedFaceId(e._id);
    setSelectedFaceIdUnique(e.template);
  };

  const submitForm = async (img, designState) => {
    if (!img?.imageBase64) {
      toastify("Image is missing", "error");
      return;
    }
    const Editedfile = base64ToFile(img?.imageBase64, img?.fullName);
    const formData = new FormData();
    formData.append("dataId", sessionForm.dataId);
    formData.append("patientId", sessionForm.dataId);
    formData.append("sessionChart", JSON.stringify(designState));
    formData.append("file", Editedfile);
    formData.append("name", img?.fullName);
    formData.append("type", "img");
    formData.append("isDefault", true);
    formData.append("template", selectedFaceIdUnique);
    formData.append("id", selectedFaceId);

    const { result, error } = await uploadSessionFiles(formData);
    if (error) {
      toastify(error.message ?? "Failed to upload image", "error");
      return;
    }
    toastify("Image Uploaded succesfully", "success");
    getEditData();
    populateSessionData();
    setDraftChart({});

    if (result?.data?.data?.updated_response?.patientChart) {
      if (result?.data?.data?.updated_response?.patientChart?.length > 0) {
        const responseData = result?.data?.data;
        if (responseData?.created_at) {
          const updatedChart = responseData?.created_at
            ? responseData?.updated_response?.patientChart.find(
                (e) => e.created_at === responseData.created_at
              )
            : responseData?.updated_response?.patientChart.find(
                (e) => e._id === selectedFaceId
              );
          console.log("DEBUG", updatedChart);
          changeFaceView(updatedChart);
        }
        // setFinalDraftChart({
        //   ...finalDraftChart,
        //   [updatedChart?.selectedFaceId]: null,
        //   [updatedChart._id]: finalDraftChart[selectedFaceId]
        // });
        // setTimeout(() => {
        //   setSelectedFaceId(updatedChart?._id);
        //   setSelectedFaceIdUnique(updatedChart?.template);
        // }, [250]);
      }
    }

    return;
  };

  const submitFormTemplate = async (img, designState) => {
    if (!img?.imageBase64) {
      toastify("Image is missing", "error");
      return;
    }
    const Editedfile = base64ToFile(img?.imageBase64, img?.fullName);
    const formData = new FormData();
    formData.append("title", title);
    formData.append("jsonChart", JSON.stringify(designState));
    formData.append("file", Editedfile);
    formData.append("type", "img");
    formData.append("template_id", selectedFaceIdUnique);
    if (isEdit) {
      formData.append("id", selectedId);
    }

    if (!isEdit) {
      const { result, error } = await createPatientChartTemplate(formData);
      if (error) {
        toastify(error.message ?? "Failed to upload image", "error");
        return;
      }
      setFinalDraftChartTemplate({});
      setTimeout(() => {
        toastify("Template Image Uploaded succesfully", "success");
        populateTemplateData();
        setDraftChartTemplate({});
        setPatientChartId(null);
        setIsEdit(false);
        setTitle("");
        setAddTemplate(false);
      }, 1000);
    } else {
      const { result, error } = await updatePatientChartTemplate(formData);
      if (error) {
        toastify(error.message ?? "Failed to upload image", "error");
        return;
      }
      setFinalDraftChartTemplate({});
      setTimeout(() => {
        toastify("Template Image Updated succesfully", "success");
        populateTemplateData();
        setDraftChartTemplate({});
        setIsEdit(false);
        setTitle("");
        setAddTemplate(false);
      }, 1000);
    }

    return;
  };
  const populateTemplates = async () => {
    const response = await getDrawtool();
    if (response?.status !== "Fail") {
      setFaces(response || []);
    } else {
      if (response?.message === "No data Found") {
        setFaces([]);
      } else {
        toastify(response?.message, "error");
      }
    }
  };
  const populatePatientChart = async () => {
    if (faces?.length > 0) {
      const jsonData = {};
      const getImage = await convertFileToBase64({ url: faces[0]?.imageUrl });
      jsonData.preview = getImage.data;

      setMarkers([]);
      setCaptions([]);

      setFinalDraftChart({
        ...finalDraftChart,
        [faces[0]._id]: {
          ...jsonData,
        },
      });
      setSelectedFaceId(faces[0]._id);
      setSelectedFaceIdUnique(faces[0]._id);
    }
  };

  useEffect(() => {
    populateTemplates();
  }, []);
  useMemo(() => {
    if (faces.length > 0) {
      populatePatientChart();
    }
  }, [faces]);
  // Function to release the Space key
  const releaseSpace = () => {
    if (isSpaceHeld) {
      setIsSpaceHeld(false);
      const event = new KeyboardEvent("keyup", {
        key: " ",
        code: "Space",
        keyCode: 32,
        which: 32,
        bubbles: true,
      });
      document.dispatchEvent(event);
    }
  };

  useEffect(() => {
    // Cleanup function to ensure key release when component unmounts
    return () => {
      if (isSpaceHeld) {
        releaseSpace();
      }
    };
  }, [isSpaceHeld]);

  const handleEdit = async (id) => {
    console.log(id);
    setIsEdit(true);
    setTitle(id.title);
    changeFaceViewTemplate(id);
    setSelectedId(id?._id);
    setAddTemplate(true);
  };

  useEffect(() => {
    const container = document.getElementsByClassName("FIE_tabs");
    const tab = document.getElementsByClassName("FIE_tools-bar-wrapper");
    if (container.length > 0) {
      container[0].children[2].children[0].innerHTML = `
        <svg height="50" width="50" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
          <path d="M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"></path>
        </svg>
      `;
      container[0].children[2]
        .querySelector("label")
        .querySelector("span").innerHTML = "Drag";
    }
    if (tab.length > 0) {
      if (tab[0].querySelector(".CUSTOM-X-ICON")) return;
      const getElementList = tab[0].children[1].children[0].children[0];
      const listItem = document.createElement("li");
      listItem.className = `${getElementList.children[1].className} CUSTOM-X-ICON`;
      const div = document.createElement("div");
      div.className = `${getElementList.children[1].children[0].className}`;
      div.setAttribute("aria-selected", "false");
      div.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.04757 38.9503C0.437373 38.3401 0.437373 37.3508 1.04757 36.7406L33.9229 3.86697L23.8354 3.33584C22.9736 3.29047 22.3118 2.5551 22.3572 1.69335C22.4026 0.831601 23.138 0.169794 23.9997 0.215167L37.5909 0.930759C38.3892 0.972794 39.027 1.61063 39.0691 2.40894L39.7846 16.0001C39.83 16.8619 39.1682 17.5972 38.3065 17.6426C37.4447 17.688 36.7093 17.0262 36.664 16.1644L36.1328 6.07651L3.25728 38.9503C2.64708 39.5605 1.65776 39.5605 1.04757 38.9503Z" fill="currentColor"></path>
        </svg>
      `;
      const label = document.createElement("label");
      label.className = `${getElementList.children[1].children[0].children[1].className}`;
      label.setAttribute("type", "default");
      const span = document.createElement("span");
      span.className = `${getElementList.children[1].children[0].children[1].children[0].className}`;
      span.textContent = "X Icon";
      label.appendChild(span);
      div.appendChild(label);
      listItem.appendChild(div);
      listItem.addEventListener("click", handleShowHideTooltip);
      getElementList.insertBefore(listItem, getElementList.firstChild);
    }
  }, [finalDraftChartTemplate]);

  useEffect(() => {
    const tab = document.querySelectorAll(
      ".FIE_modal_custom .FIE_tools-bar-wrapper"
    );
    console.log("length", tab.length);
    if (tab.length > 0) {
      if (tab[0].querySelector(".CUSTOM-X-ICON")) return;
      const getElementList = tab[0].children[1].children[0].children[0];
      const listItem = document.createElement("li");
      listItem.className = `${getElementList.children[1].className} CUSTOM-X-ICON`;
      const div = document.createElement("div");
      div.className = `${getElementList.children[1].children[0].className}`;
      div.setAttribute("aria-selected", "false");
      div.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.04757 38.9503C0.437373 38.3401 0.437373 37.3508 1.04757 36.7406L33.9229 3.86697L23.8354 3.33584C22.9736 3.29047 22.3118 2.5551 22.3572 1.69335C22.4026 0.831601 23.138 0.169794 23.9997 0.215167L37.5909 0.930759C38.3892 0.972794 39.027 1.61063 39.0691 2.40894L39.7846 16.0001C39.83 16.8619 39.1682 17.5972 38.3065 17.6426C37.4447 17.688 36.7093 17.0262 36.664 16.1644L36.1328 6.07651L3.25728 38.9503C2.64708 39.5605 1.65776 39.5605 1.04757 38.9503Z" fill="currentColor"></path>
        </svg>
      `;
      const label = document.createElement("label");
      label.className = `${getElementList.children[1].children[0].children[1].className}`;
      label.setAttribute("type", "default");
      const span = document.createElement("span");
      span.className = `${getElementList.children[1].children[0].children[1].children[0].className}`;
      span.textContent = "X Icon";
      label.appendChild(span);
      div.appendChild(label);
      listItem.appendChild(div);
      listItem.addEventListener("click", handleShowHideTooltipTemplate);
      getElementList.insertBefore(listItem, getElementList.firstChild);
    }
  }, [addTemplate]);

  const changeFaceViewTemplate = async (e) => {
    const updatedFinalDraftChart = JSON.parse(
      JSON.stringify(finalDraftChartTemplate)
    );

    if (!draftChartTemplate[e.template_id]) {
      if (e.jsonChart) {
        const templateFace = faces.find((f) => f._id === e.template_id);
        console.log(templateFace);
        if (templateFace) {
          const getImage = await convertFileToBase64({
            url: templateFace.imageUrl,
          });
          const jsonChart = JSON.parse(e.jsonChart);
          updatedFinalDraftChart[e.template_id] = {
            preview: getImage.data,
            jsonChart: jsonChart,
            template: templateFace,
            name: e.name,
          };
        }
      }
    }
    console.log(updatedFinalDraftChart);
    setFinalDraftChartTemplate(updatedFinalDraftChart);
  };
  const addElementAnnotationTemplate = async (x, y) => {
    !x && !y && handleShowHideTooltipTemplate();
    let imageIconURL;

    if (stateIconRef) {
      const canvas = await html2canvas(stateIconRef, { backgroundColor: null });
      const imgData = canvas.toDataURL("image/png");
      imageIconURL = imgData;
    }
    const time = `Image-${new Date().getTime()}`;
    const image = await new Promise((resolve, reject) => {
      const image = new Image();
      image.src = `data:application/image;base64,${finalDraftChart?.[selectedFaceId]?.preview}`;
      image.onload = function () {
        resolve({
          width: image.width,
          height: image.height,
        });
        image.onerror = function () {
          resolve({
            width: 0,
            height: 0,
          });
        };
      };
    });

    const getCurrentContainerRef = imageGetRef.current();
    if (!getCurrentContainerRef) {
      return;
    }
    const { width, height } =
      getCurrentContainerRef.designState.shownImageDimensions;
    const finalX =
      x && width ? (width * parseFloat(x)) / 100 - 15 : image.width / 2;
    const finalY =
      y && height ? (height * parseFloat(y)) / 100 - 15 : image.height / 4;
    const annotation = {
      [time]: {
        fill: undefined,
        stroke: "#000000",
        strokeWidth: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowBlur: 0,
        shadowColor: "#000000",
        shadowOpacity: 1,
        opacity: 1,
        disableUpload: true,
        gallery: [
          {
            originalUrl: imageIconURL,
            previewUrl: imageIconURL,
          },
        ],
        name: "Image",
        image: imageIconURL,
        x: finalX,
        y: finalY,
        width: 30,
        height: 30,
        id: time,
      },
    };

    const annotationReturn = {
      id: time,
      fill: undefined,
      stroke: "#000000",
      strokeWidth: 0,
      shadowOffsetX: 0,
      shadowOffsetY: 0,
      shadowBlur: 0,
      shadowColor: "#000000",
      shadowOpacity: 1,
      opacity: 1,
      disableUpload: true,
      gallery: [
        {
          originalUrl: imageIconURL,
          previewUrl: imageIconURL,
        },
      ],
      name: "Image",
      image: imageIconURL,
      x: finalX,
      y: finalY,
      width: 30,
      height: 30,
      id: time,
    };
    return annotationReturn;
    // setFinalDraftChartTemplate((oldValue) => {
    //   return {
    //     ...draftChartTemplate,
    //     [selectedFaceId]: {
    //       preview: finalDraftChartTemplate?.[selectedFaceId]?.preview,
    //       jsonChart: {
    //         ...draftChartTemplate[selectedFaceId],
    //         annotations: {
    //           ...(draftChartTemplate[selectedFaceId]?.annotations || {}),
    //           ...annotation,
    //         },
    //         imgSrc: `data:application/image;base64,${finalDraftChartTemplate?.[selectedFaceId]?.preview}`,
    //       },
    //     },
    //   };
    // });
    // setDraftChartTemplate((oldValue) => {
    //   return {
    //     ...oldValue,
    //     [selectedFaceId]: {
    //       ...oldValue[selectedFaceId],
    //       annotations: {
    //         ...(oldValue[selectedFaceId]?.annotations || {}),
    //         ...annotation,
    //       },
    //       imgSrc: `data:application/image;base64,${finalDraftChart?.[selectedFaceId]?.preview}`,
    //     },
    //   };
    // });
  };

  const changeFaceTemplate = async (e) => {
    // updateDesignLayer();
    resetTotal();

    setMarkers([]);
    setCaptions([]);
    setisPrevious(false);

    const getImage = await convertFileToBase64({ url: e.imageUrl });
    const preview = getImage.data;
    let faceData = {};
    if (!draftChartTemplate[e._id]) {
      faceData = {
        [e._id]: {
          preview: preview,
          jsonChart: null,
          template: e,
        },
      };
    } else {
      faceData = {
        [e._id]: {
          preview: preview,
          jsonChart: JSON.parse(JSON.stringify(draftChartTemplate[e._id])),
          template: e,
        },
      };
    }

    setFinalDraftChartTemplate({
      ...finalDraftChartTemplate,
      ...faceData,
    });

    setSelectedFaceId(e._id);
    setSelectedFaceIdUnique(e._id);

    const container = document.getElementsByClassName("FIE_tabs");
    if (container.length > 0) {
      container[0].children[2].children[0].innerHTML = `
        <svg height="50" width="50" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
          <path d="M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"></path>
        </svg>
      `;
      container[0].children[2]
        .querySelector("label")
        .querySelector("span").innerHTML = "Drag";
    }
  };

  const handleDelte = async (id) => {
    const response = await deletePatientChartTemplate({ id: id });
    if (response?.status !== "Fail") {
      populateTemplateData();
      toastify("Deletd successfully!", "success");
    } else {
      toastify(response?.message, "error");
    }
  };

  function generateRandomId(length) {
    return Math.random()
      .toString()
      .slice(2, 2 + length);
  }
  const handleAddTemplate = async (e) => {
    // updateDesignLayer();
    resetTotal();
    setMarkers([]);
    setCaptions([]);
    setisPrevious(false);

    const getImage = await convertFileToBase64({
      url: faces.find((a) => a?._id === e.template_id).imageUrl,
    });
    const preview = getImage.data;
    let faceData = {};

    if (!draftChart[e.template_id]) {
      faceData = {
        [e._id]: {
          preview: preview,
          jsonChart: null,
          template: e,
        },
      };
    } else {
      const annotations = JSON.parse(e?.jsonChart).annotations;
      const updatedAnnotations = {};

      Object.keys(annotations).forEach((key) => {
        // Extract the prefix and random number
        const prefix = key.split("-")[0];
        const randomNumberLength = key.split("-")[1].length;

        // Generate a new random number with the same length
        const newRandomNumber = generateRandomId(randomNumberLength);

        // Construct the new key
        const newKey = `${prefix}-${newRandomNumber}`;

        // Copy the annotation data to a new object and update the 'id' field to match the new key
        const updatedAnnotation = { ...annotations[key], id: newKey };

        // Assign the updated annotation to the new key
        updatedAnnotations[newKey] = updatedAnnotation;
      });

      faceData = {
        [selectedFaceId]: {
          preview: preview,
          jsonChart: {
            ...JSON.parse(JSON.stringify(draftChart[selectedFaceId])),
            annotations: {
              ...draftChart[selectedFaceId]?.annotations,
              ...updatedAnnotations,
            },
          },
          template: e,
        },
      };
    }

    setFinalDraftChart({
      ...finalDraftChart,
      ...faceData,
    });

    const container = document.getElementsByClassName("FIE_tabs");
    if (container.length > 0) {
      container[0].children[2].children[0].innerHTML = `
        <svg height="50" width="50" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
          <path d="M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"></path>
        </svg>
      `;
      container[0].children[2]
        .querySelector("label")
        .querySelector("span").innerHTML = "Drag";
    }

    setShow(false);
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const sessionCounts = {};
  return (
    <>
      {" "}
      <div className="pr-4 mb-5 pb-4 h-100 first-patient-chart">
        <TooltipComponent
          message="This is a tooltip"
          show={showTooltip}
          setShowTooltip={setShowTooltip}
          resetSelectFirstChart={resetSelectFirstChart}
          target={tooltipTarget}
          addElementAnnotation={() => addElementAnnotation()}
          currentColor={currentColor}
          setCurrentColor={setCurrentColor}
          xIconRef={iconRef}
          enableClick={enableClick}
          setEnableClick={setEnableClick}
          isBodyVisible={isBodyVisible}
          setIsBodyVisible={setIsBodyVisible}
          setStateIconRef={setStateIconRef}
        />
        <div className="mainHeading">
          <h1>
            Drawtool Template{" "}
            <PlagiarismIcon
              sx={{ ml: 2, cursor: "pointer" }}
              onClick={(event) => {
                event.stopPropagation();
                handleShow();
              }}
            />
          </h1>
        </div>

        <div className="image-container-1 pb-4" style={{ marginTop: "-20px" }}>
          {faces &&
            faces?.length > 0 &&
            faces?.map((e, i) => (
              <div key={i}>
                <div
                  className="d-flex p-2 mx-3 drawtool-list"
                  style={{ border: "1px solid gray", marginTop: "25px" }}
                >
                  <img
                    src={e.imageUrl}
                    alt="img"
                    className="drawtool-images"
                    style={{ width: "100%" }}
                    onClick={() => {
                      changeFace(e);
                    }}
                  />
                </div>
                <div className="text-center">{`Template - ${e.title}`}</div>
              </div>
            ))}
          {sessionData &&
            sessionData?.length > 0 &&
            sessionData?.map(
              (e, i) =>
                e?.length != 0 &&
                e.map((a) => {
                  const date = formatDate(a.date); // Format the date for display
                  // Initialize or increment the session count for this date
                  sessionCounts[date] = (sessionCounts[date] || 0) + 1;

                  return (
                    <div key={i}>
                      <div>
                        <HighlightOffIcon
                          sx={{
                            position: "relative",
                            cursor: "pointer",
                            marginLeft: "20px",
                            top: "28px",
                          }}
                          onClick={() => {
                            setPatientChartId({
                              chartId: a._id,
                              sessionId: a?.sessionId,
                            });
                            setShowConfirmation(true);
                          }}
                        />
                      </div>

                      <div
                        className="d-flex p-2 mx-3 drawtool-list"
                        style={{ border: "1px solid gray" }}
                      >
                        <img
                          src={a.link}
                          alt="img"
                          className="drawtool-images"
                          style={{ width: "100%" }}
                          onClick={() => {
                            changeFaceView(a);
                          }}
                        />
                      </div>
                      <div className="text-center">
                        {`Session ${sessionCounts[date]} - ${date}`}
                      </div>
                    </div>
                  );
                })
            )}
        </div>

        <div
          className={`drag-container ${
            isFullScreen ? "fullscreen" : ""
          } bot-editor`}
        >
          <div
            className={`${
              tab === "zoomin" || tab === "pen" ? "zoom-kro" : "na-kro "
            }`}
          >
            <div
              style={{ display: !finalDraftChart?.[selectedFaceId] && "none" }}
            >
              <div
                className={`FIE_custom w-100 draw-box ${
                  !disabled ? "" : "hide-btn"
                }`}
              >
                <button
                  className="button-fullscreen"
                  onClick={() => setIsFullScreen(!isFullScreen)}
                >
                  {isFullScreen ? "Exit Fullscreen" : "Fullscreen"}
                </button>
                <FilerobotImageEditor
                  ref={editorRef}
                  getCurrentImgDataFnRef={imageGetRef}
                  updateStateFnRef={imageUpRef}
                  loadableDesignState={
                    finalDraftChart?.[selectedFaceId]?.jsonChart
                      ? finalDraftChart?.[selectedFaceId]?.jsonChart
                      : null
                  }
                  source={`data:application/image;base64, ${
                    finalDraftChart?.[selectedFaceId]?.preview || defaultPreview
                  }`}
                  onSave={(editedImageObject, designState) => {
                    submitForm(editedImageObject, designState);
                  }}
                  onClickImagePosition={(x, y) => {
                    if (enableClick) {
                      return addElementAnnotation(x, y);
                    }
                  }}
                  onModify={(currentImageDesignState) => {
                    setDraftChart({
                      ...draftChart,
                      [selectedFaceId]: {
                        name: finalDraftChart?.[selectedFaceId]?.name,
                        adjustments: currentImageDesignState.adjustments,
                        annotations: currentImageDesignState.annotations,
                        filter: currentImageDesignState.filter,
                        finetunes: currentImageDesignState.finetunes,
                        finetunesProps: currentImageDesignState.finetunesProps,
                        imgSrc: `data:application/image;base64, ${finalDraftChart?.[selectedFaceId]?.preview}`,
                        resize: currentImageDesignState.resize,
                        shownImageDimensions:
                          currentImageDesignState.shownImageDimensions,
                      },
                    });
                  }}
                  annotationsCommon={{
                    fill: "#000000",
                    stroke: "#000000",
                    strokeWidth: 1,
                  }}
                  Text={{
                    fill: "#000000",
                    strokeWidth: 0,
                    text: "",
                    fontFamily: "Arial",
                    fonts: [],
                    fontSize: 36,
                    letterSpacing: 0,
                    lineHeight: 1,
                    align: "left",
                    fontStyle: "normal",
                  }}
                  Image={{
                    strokeWidth: 0,
                    shadowOffsetX: 0,
                    shadowOffsetY: 0,
                    shadowBlur: 0,
                  }}
                  Rect={{
                    fill: "#00000000",
                    strokeWidth: 3,
                  }}
                  Ellipse={{
                    fill: "#00000000",
                    strokeWidth: 3,
                  }}
                  Arrow={{
                    strokeWidth: 2,
                    pointerWidth: 18,
                    pointerLength: 18,
                    fill: "white",
                  }}
                  Line={{
                    strokeWidth: 2,
                  }}
                  Rotate={{ angle: 90, componentType: "slider" }}
                  tabsIds={["Adjust", "Annotate", "Resize"]}
                  defaultTabId={TABS.ANNOTATE}
                  defaultToolId={TOOLS.POLYGON}
                  defaultSavedImageName={new Date().getTime().toString()}
                  defaultSavedImageQuality={1}
                  resetOnImageSourceChange={true}
                  annotationsEditor={{
                    isDraggable: true,
                    isResizable: true,
                  }}
                  imageEditor={{
                    isPannable: true,
                    isZoomable: true,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Modal show={show} onHide={handleClose} size="xl"> */}
      <div
        className="modal fade show"
        tabindex="-1"
        style={{ display: show ? "block" : "none" }}
      >
        <div
          className="modal-dialog modal-xl"
          role="document"
          style={{
            zIndex: 1051,
            position: isFullScreenTemplate ? "absolute" : undefined,
            marginTop: isFullScreenTemplate ? "0" : undefined,
          }}
        >
          <div
            className="modal-content"
            style={{ width: isFullScreenTemplate ? "100vw" : undefined }}
          >
            {!isFullScreenTemplate && (
              <Modal.Header>
                <Modal.Title>
                  Templates{" "}
                  {!addTemplate && (
                    <AddBoxIcon
                      sx={{ ml: 2, cursor: "pointer" }}
                      onClick={() => {
                        setAddTemplate(true);
                        changeFaceTemplate(
                          faces.find((a) => a?._id == selectedFaceIdUnique)
                        );
                      }}
                    />
                  )}
                </Modal.Title>
                <CloseButton onClick={handleClose} style={{}} />
              </Modal.Header>
            )}

            <Modal.Body>
              <div style={{ display: addTemplate && "none" }}>
                {templateData
                  ?.filter((a) => a?.template_id == selectedFaceIdUnique)
                  .map((e, index) => (
                    <ListGroup.Item
                      key={index}
                      as="li"
                      className="d-flex justify-content-between align-items-center mb-2 border rounded"
                    >
                      <div
                        className="ms-2 me-auto cursor-pointer p-2 w-full"
                        onClick={() => {
                          handleAddTemplate(e);
                        }}
                      >
                        <div className="fw-bold">{e.title}</div>
                      </div>
                      <EditIcon
                        sx={{ cursor: "pointer", marginRight: "10px" }}
                        onClick={() => {
                          handleEdit(e);
                        }}
                      />
                      <CloseIcon
                        sx={{ cursor: "pointer", marginRight: "10px" }}
                        onClick={() => {
                          handleDelte(e?._id);
                        }}
                      />
                    </ListGroup.Item>
                  ))}
              </div>
              <>
                <div style={{ display: !addTemplate && "none" }}>
                  {!isFullScreenTemplate && (
                    <Form.Group>
                      <div className="h5">Template Title *</div>
                      <InputGroup className="mb-3">
                        <Form.Control
                          placeholder="Write..."
                          onChange={(e) => {
                            setTitle(e.target.value);
                          }}
                          value={title}
                        />
                      </InputGroup>
                    </Form.Group>
                  )}

                  <Form.Group>
                    {!isFullScreenTemplate && (
                      <div className="h5">Template Details *</div>
                    )}

                    <InputGroup>
                      <TooltipComponentTemplate
                        message="This is a tooltip"
                        show={showTooltipTemplate}
                        setShowTooltip={setShowTooltipTemplate}
                        resetSelectSecondChart={resetSelectSecondChart}
                        target={tooltipTargetTemplate}
                        addElementAnnotation={() =>
                          addElementAnnotationTemplate()
                        }
                        currentColor={currentColor}
                        setCurrentColor={setCurrentColor}
                        xIconRef={iconRef}
                        enableClick={enableClick}
                        setEnableClick={setEnableClick}
                        isBodyVisible={isBodyVisibleTemplate}
                        setIsBodyVisible={setIsBodyVisibleTemplate}
                        setStateIconRef={setStateIconRef}
                        placement="top"
                      />
                      <div
                        className={`drag-container w-full ${
                          isFullScreenTemplate ? "fullscreen" : ""
                        } bot-editor`}
                        style={{
                          position: isFullScreenTemplate ? "fixed" : undefined,
                        }}
                      >
                        <div
                          className={`${
                            tab === "zoomin" || tab === "pen"
                              ? "zoom-kro"
                              : "na-kro "
                          }`}
                        >
                          <div
                            style={{
                              display:
                                !finalDraftChart?.[selectedFaceId] && "none",
                            }}
                          >
                            <div
                              className={`w-100 ${
                                !disabled ? "" : "hide-btn"
                              } ${isFullScreenTemplate ? "draw-box" : ""}`}
                            >
                              <button
                                className="button-fullscreen"
                                onClick={() => {
                                  setIsFullScreenTemplate(
                                    !isFullScreenTemplate
                                  );
                                }}
                              >
                                {isFullScreenTemplate
                                  ? "Exit Fullscreen"
                                  : "Fullscreen"}
                              </button>
                              <div
                                className="FIE_modal_custom"
                                style={{
                                  position: isFullScreenTemplate
                                    ? "relative"
                                    : undefined,
                                  display: isFullScreenTemplate
                                    ? "flex"
                                    : undefined,
                                  height: isFullScreenTemplate
                                    ? "100%"
                                    : undefined,
                                }}
                              >
                                <FilerobotImageEditor
                                  ref={editorRefTemplate}
                                  getCurrentImgDataFnRef={imageGetTemplateRef}
                                  updateStateFnRef={imageUpTemplateRef}
                                  loadableDesignState={
                                    finalDraftChartTemplate?.[
                                      selectedFaceIdUnique
                                    ]?.jsonChart
                                      ? finalDraftChartTemplate?.[
                                          selectedFaceIdUnique
                                        ]?.jsonChart
                                      : null
                                  }
                                  source={`data:application/image;base64, ${
                                    finalDraftChartTemplate?.[
                                      selectedFaceIdUnique
                                    ]?.preview || defaultPreview
                                  }`}
                                  onSave={(editedImageObject, designState) => {
                                    submitFormTemplate(
                                      editedImageObject,
                                      designState
                                    );
                                  }}
                                  onClickImagePosition={(x, y) => {
                                    if (enableClick) {
                                      return addElementAnnotationTemplate(x, y);
                                    }
                                  }}
                                  onModify={(currentImageDesignState) => {
                                    setDraftChartTemplate({
                                      ...draftChartTemplate,
                                      [selectedFaceIdUnique]: {
                                        name: finalDraftChartTemplate?.[
                                          selectedFaceIdUnique
                                        ]?.name,
                                        adjustments:
                                          currentImageDesignState.adjustments,
                                        annotations:
                                          currentImageDesignState.annotations,
                                        filter: currentImageDesignState.filter,
                                        finetunes:
                                          currentImageDesignState.finetunes,
                                        finetunesProps:
                                          currentImageDesignState.finetunesProps,
                                        imgSrc: `data:application/image;base64, ${finalDraftChart?.[selectedFaceIdUnique]?.preview}`,
                                        resize: currentImageDesignState.resize,
                                        shownImageDimensions:
                                          currentImageDesignState.shownImageDimensions,
                                      },
                                    });
                                  }}
                                  annotationsCommon={{
                                    fill: "#000000",
                                    stroke: "#000000",
                                    strokeWidth: 1,
                                  }}
                                  Text={{
                                    fill: "#000000",
                                    strokeWidth: 0,
                                    text: "",
                                    fontFamily: "Arial",
                                    fonts: [],
                                    fontSize: 36,
                                    letterSpacing: 0,
                                    lineHeight: 1,
                                    align: "left",
                                    fontStyle: "normal",
                                  }}
                                  Image={{
                                    strokeWidth: 0,
                                    shadowOffsetX: 0,
                                    shadowOffsetY: 0,
                                    shadowBlur: 0,
                                  }}
                                  Rect={{
                                    fill: "#00000000",
                                    strokeWidth: 3,
                                  }}
                                  Ellipse={{
                                    fill: "#00000000",
                                    strokeWidth: 3,
                                  }}
                                  Arrow={{
                                    strokeWidth: 2,
                                    pointerWidth: 18,
                                    pointerLength: 18,
                                    fill: "white",
                                  }}
                                  Line={{
                                    strokeWidth: 2,
                                  }}
                                  Rotate={{
                                    angle: 90,
                                    componentType: "slider",
                                  }}
                                  tabsIds={["Adjust", "Annotate", "Resize"]}
                                  defaultTabId={TABS.ANNOTATE}
                                  defaultToolId={TOOLS.TEXT}
                                  defaultSavedImageName={new Date()
                                    .getTime()
                                    .toString()}
                                  defaultSavedImageQuality={1}
                                  resetOnImageSourceChange={true}
                                  annotationsEditor={{
                                    isDraggable: true,
                                    isResizable: true,
                                  }}
                                  imageEditor={{
                                    isPannable: true,
                                    isZoomable: true,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </InputGroup>
                  </Form.Group>
                </div>
              </>
            </Modal.Body>
          </div>
        </div>
        <div className="modal-backdrop fade show" onClick={handleClose}></div>
      </div>
      {/* </Modal> */}
      <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Please confirm to Delete Session Patient Chart</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmation(false)}
          >
            Cancel
          </Button>
          <Button variant="danger" onClick={() => removePatientChart()}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default function PatientDetails() {
  const [currentState, setCurrentState] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { sessionForm } = useSelector((state) => state.staffForm);
  const userData = useSelector((state) => state.userData.value);
  const [patientHistory, setPatientHistory] = useState([]);
  const [ptData, setPtData] = useState([]);
  const [saveData, setSaveData] = useState(0);
  const [successSaveData, setSuccessSaveData] = useState({
    mh: undefined,
    soap: undefined,
    ps: undefined,
  });

  const [openMedicalCertificate, setOpenMedicalCertificate] = useState(false);
  console.log("userData", userData);
  const isDoctor = userData?.department?.name
    ?.toLowerCase()
    ?.includes("doctor");
  const [photo, setPhoto] = useState(
    location?.state?.valueObj?.photoSession ?? ""
  );
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [openCamera, setOpenCamera] = useState(false);

  const adjustCurrentState = (state) => {
    setCurrentState(state);
    localStorage.setItem("session_current_state", state);
  };

  useEffect(() => {
    if (
      successSaveData.mh !== undefined &&
      successSaveData.soap !== undefined &&
      successSaveData.ps !== undefined
    ) {
      if (successSaveData.mh && successSaveData.soap && successSaveData.ps) {
        toastify("Success", "success");
      }
      setSuccessSaveData({ mh: undefined, soap: undefined, ps: undefined });
    }
  }, [successSaveData]);

  useEffect(() => {
    if (sessionForm.patientID) {
      getPatientDetailsById(sessionForm.patientID).then((res) => {
        setSelectedPatient(res);
      });
    }
  }, [sessionForm.patientID]);

  useEffect(() => {
    if (location?.state?.valueObj) {
      dispatch(
        setData({
          parent: "sessionForm",
          value: location?.state?.valueObj,
        })
      );
    } else {
      if (!sessionForm.dataId) {
        navigate(-1);
      }
    }
  }, [location?.state?.valueObj, sessionForm.dataId]);

  useEffect(() => {
    const curState = localStorage.getItem("session_current_state");
    if (!curState) {
      localStorage.setItem(
        "session_current_state",
        SESSION_CURRENT_STATE.patientMedicalHistory
      );
    } else {
      setCurrentState(curState);
    }
  }, [localStorage.getItem("session_current_state")]);

  const handleTakePhoto = (dataUri) => {
    setPhoto(dataUri);
  };

  const handleSavePhoto = async () => {
    const sessionForm = location?.state?.valueObj;
    const photoName = `Photo Session`;
    const Editedfile = base64ToFile(photo, photoName);

    const formData = new FormData();
    formData.append("dataId", sessionForm.dataId);
    formData.append("patientId", sessionForm.dataId);

    formData.append("file", Editedfile);
    formData.append("name", photoName);
    formData.append("type", "img");

    const { result, error } = await updateSessionPhoto(formData);
    if (error) {
      toastify(error.message ?? "Failed to upload image", "error");
      setOpenCamera(false);
    } else {
      toastify("Image Uploaded succesfully", "success");
      setOpenCamera(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (sessionForm.patientID) {
        const { result, error } = await getSessionByPatientId(
          sessionForm.patientID
        );
        if (error) {
          toastify(error.message, "error");
          return;
        }
        const tempArr = result?.data
          ?.filter((d) => d._id !== sessionForm.dataId)
          ?.map((e) => {
            const historyObj = {
              medicalHistory: e.patientMedicalHistory?.pastMedicalHistory,
              cosmeticHistory: e.patientMedicalHistory?.pastCosmeticHistory,
              adverseCosmeticHistory:
                e.patientMedicalHistory?.pastAdverseCosmeticHistory,
              socialHistory: e.patientMedicalHistory?.socialHistory,
            };
            const loc = e?.branch?.location?.find((o) => o._id === e?.location);

            let totalAmount = 0;
            const prescriptionDrugs = e?.patientPrescriptionSheet?.map((o) => {
              totalAmount +=
                o.type === "internal"
                  ? o.quantity * o.unitPrice - o.discount
                  : 0;

              return {
                name: o.drugName,
                price: o.unitPrice ? o.unitPrice : 0,
                qty: o.quantity,
                discount: o.discount ? o.discount : 0,
                total_price:
                  o.type === "internal"
                    ? o.quantity * o.unitPrice - o.discount
                    : 0,
                instruction: o.instruction,
                type: o.type,
              };
            });

            const taxVal = e.prescriptionGSTAmount;
            const notesObj = {
              startTime: e.startTime,
              endTime: e.endTime,
              staff: e.staff?.map((o) => o?.username),
              soap: e.patientSOAP,
              location: loc,

              service: [...prescriptionDrugs],

              totalAmount: totalAmount,
              afterTaxValue: taxVal,
            };
            return {
              _id: e._id,
              date: new Date(e.date).toLocaleDateString(),
              history: historyObj,
              patientMedicalHistory: e.patientMedicalHistory,
              notes: notesObj,
            };
          });
        setPatientHistory(JSON.parse(JSON.stringify([...tempArr.reverse()])));

        const response = await getMedicalInfo(sessionForm.patientID);
        if (response?.status !== "Fail") {
          setPtData(response);
        }
      }
    })();
  }, [sessionForm.patientID]);

  useEffect(() => {
    getSessionById(sessionForm.dataId).then((res) => {
      if (res?.result?.data) {
        dispatch(
          setData({
            parent: "sessionForm",
            // child: "patientMedicalHistory",
            value: {
              ...sessionForm,
              patientMedicalHistory: res?.result?.data?.patientMedicalHistory
                ? res?.result?.data?.patientMedicalHistory
                : sessionForm.patientMedicalHistory,
              patientSOAP: res?.result?.data?.patientSOAP
                ? res?.result?.data?.patientSOAP
                : sessionForm.patientSOAP,
              // patientChart: res?.result?.data?.patientChart ? res?.result?.data?.patientChart : sessionForm.patientChart,
              patientPrescriptionSheet: res?.result?.data
                ?.patientPrescriptionSheet
                ? res?.result?.data?.patientPrescriptionSheet
                : sessionForm.patientPrescriptionSheet,
            },
          })
        );
      }
    });
  }, [sessionForm.dataId]);

  const ptmapdata = ptData?.map((e, index) => {
    return {
      id: e._id,
      index: index,
      date: e.date ? new Date(e.date).toLocaleDateString() : "",
      type: e.type,
      description: e.description,
    };
  });

  const [editLogs, setEditLogs] = useState();

  const getEditData = async () => {
    const response = await getEditBy({
      id: sessionForm.dataId,
      type: "Session",
    });
    setEditLogs(response);
  };
  useEffect(() => {
    getEditData();
  }, []);

  const openQuestionnaire = () => {
    window
      .open(`/medicalform/${sessionForm.patientID}?ph=true`, "_blank")
      .focus();
  };
  console.log("openMedicalCertificate", openMedicalCertificate);
  return (
    <>
      {/* <div className="mainHeading px-4">
        <div>
          <h1>
            <i
              className="fa fa-arrow-left cursor-pointer"
              onClick={() => {
                navigate(-1);
              }}
            ></i>
            {currentState} ({selectedPatient?.patientProfile?.fullName})
            {isDoctor && (
              <i>
                <InfoOutlinedIcon
                  style={{
                    marginLeft: "5px",
                    fontSize: 25,
                    color: "#365c78",
                    cursor: "pointer",
                  }}
                  onClick={openQuestionnaire}
                ></InfoOutlinedIcon>
              </i>
            )}
          </h1>
          {editLogs && (
            <div style={{ marginLeft: "5px" }}>
              {" "}
              By {editLogs?.userName} At{" "}
              {moment(editLogs?.created_at).format("DD/MM/YYYY hh:mm:ss")}
            </div>
          )}
        </div>
        <div>
          <LinkedCameraIcon
            onClick={() => setOpenCamera(true)}
            style={{ fontSize: 30, color: "#365c78", cursor: "pointer" }}
          />
          <ModalCamera
            openModal={openCamera}
            setOpenModal={setOpenCamera}
            handleTakePhoto={handleTakePhoto}
            handleSave={handleSavePhoto}
            photo={photo}
            existingPhoto={location?.state?.valueObj?.photoSession ?? ""}
          />
        </div>
      </div> */}
      <div className="mainHeading px-4">
        <div>
          <h1>
            <i
              className="fa fa-arrow-left cursor-pointer"
              onClick={() => navigate(-1)}
            ></i>
            {currentState} ({selectedPatient?.patientProfile?.fullName})
            {isDoctor && (
              <i>
                <InfoOutlinedIcon
                  style={{
                    marginLeft: "5px",
                    fontSize: 25,
                    color: "#365c78",
                    cursor: "pointer",
                  }}
                  onClick={openQuestionnaire}
                ></InfoOutlinedIcon>
              </i>
            )}
          </h1>
          {editLogs && (
            <div style={{ marginLeft: "5px" }}>
              By {editLogs?.userName} At{" "}
              {moment(editLogs?.created_at).format("DD/MM/YYYY hh:mm:ss")}
            </div>
          )}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <LinkedCameraIcon
            onClick={() => setOpenCamera(true)}
            style={{ fontSize: 30, color: "#365c78", cursor: "pointer" }}
          />

          {/* ➕ Create Medical Certificate Button */}
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenMedicalCertificate(true)}
            style={{ backgroundColor: "#365c78", color: "#fff" }}
          >
            Medical Certificate
          </Button>
        </div>

        {/* 📄 Medical Certificate Modal */}
        <Dialog
          open={openMedicalCertificate}
          onClose={() => setOpenMedicalCertificate(false)}
          maxWidth="lg"
          fullWidth
        >
          <MedicalCertificate
            patient={selectedPatient}
            isDoctor={isDoctor}
            userData={userData}
            onClose={() => setOpenMedicalCertificate(false)}
          />
        </Dialog>

        <ModalCamera
          openModal={openCamera}
          setOpenModal={setOpenCamera}
          handleTakePhoto={handleTakePhoto}
          handleSave={handleSavePhoto}
          photo={photo}
          existingPhoto={location?.state?.valueObj?.photoSession ?? ""}
        />
      </div>

      <div className="w-100 d-flex justify-content-center">
        {isDoctor && (
          <React.Fragment>
            <Button
              className={`${
                currentState === SESSION_CURRENT_STATE.patientMedicalHistory
                  ? "theme-rounded-button"
                  : "white-rounded-button"
              } ms-3 mb-3 responsive-btn`}
              onClick={() => {
                adjustCurrentState(SESSION_CURRENT_STATE.patientMedicalHistory);
              }}
            >
              Patient Medical History
            </Button>
            <Button
              className={`${
                currentState === SESSION_CURRENT_STATE.patientSOAP
                  ? "theme-rounded-button"
                  : "white-rounded-button"
              } ms-3 mb-3 responsive-btn`}
              onClick={() => {
                adjustCurrentState(SESSION_CURRENT_STATE.patientSOAP);
              }}
            >
              Patient SOAP
            </Button>
          </React.Fragment>
        )}
        <Button
          className={`${
            currentState === SESSION_CURRENT_STATE.patientConsents
              ? "theme-rounded-button"
              : "white-rounded-button"
          } ms-3 mb-3 responsive-btn`}
          onClick={() => {
            adjustCurrentState(SESSION_CURRENT_STATE.patientConsents);
          }}
        >
          Patient Consents
        </Button>
        <Button
          className={`${
            currentState === SESSION_CURRENT_STATE.patientChart
              ? "theme-rounded-button"
              : "white-rounded-button"
          } ms-3 mb-3 responsive-btn`}
          onClick={() => {
            adjustCurrentState(SESSION_CURRENT_STATE.patientChart);
          }}
        >
          Patient Chart
        </Button>
        {isDoctor && (
          <React.Fragment>
            <Button
              className={`${
                currentState === SESSION_CURRENT_STATE.patientPrescriptionSheet
                  ? "theme-rounded-button"
                  : "white-rounded-button"
              } ms-3 mb-3 responsive-btn`}
              onClick={() => {
                adjustCurrentState(
                  SESSION_CURRENT_STATE.patientPrescriptionSheet
                );
              }}
            >
              Patient Prescription Sheet
            </Button>
          </React.Fragment>
        )}
        <Button
          className={`${
            currentState === SESSION_CURRENT_STATE.patientCaseFolder
              ? "theme-rounded-button"
              : "white-rounded-button"
          } ms-3 mb-3 responsive-btn`}
          onClick={() => {
            adjustCurrentState(SESSION_CURRENT_STATE.patientCaseFolder);
          }}
        >
          Case Folder
        </Button>
      </div>
      <div className="patient-details-body">
        <Row>
          <Col>
            {" "}
            <div
              style={{
                padding: "25px",
                paddingTop: "0px",
                paddingRight: "0px",
                height: "calc(100vh - 210px)",
                overflow: "auto",
              }}
            >
              <div
                className="details-container white-background align-self-stretch "
                style={{
                  border: "1px solid #E9E9E9",
                  padding: "15px",
                }}
              >
                <Form.Label className="black-label-text">
                  Medical Information
                </Form.Label>
                {ptmapdata?.length > 0 &&
                  ptmapdata?.map((e, i) => {
                    return (
                      <div className="accordion-patient">
                        <Accordion defaultActiveKey={"0"}>
                          <Accordion.Item
                            eventKey="0"
                            style={{
                              border: "none",
                              outline: "none",
                            }}
                          >
                            <Accordion.Header>
                              <div className="bold font-14">{e.date}</div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <div>
                                <div>
                                  <div>
                                    <ListGroup.Item
                                      as="li"
                                      className="d-flex justify-content-between align-items-start mb-2 border p-2 rounded"
                                    >
                                      <div className="ms-2 me-auto cursor-pointer">
                                        <div>
                                          {e.type} : {e.description}
                                        </div>
                                      </div>
                                    </ListGroup.Item>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    );
                  })}
                {/* <div className="addressDetail">
                  <div className="detailPadding d-flex">
                    <i className="fa fa-user"></i>
                    <h6 className="ms-2">
                      {selectedPatient?.patientProfile?.fullName
                        ? selectedPatient?.patientProfile?.fullName
                        : "-"}
                    </h6>
                  </div>
                  <div className="detailPadding d-flex">
                    <i className="fa fa-envelope"></i>
                    <h6 className="ms-2">
                      {selectedPatient?.patientProfile?.email
                        ? selectedPatient?.patientProfile?.email
                        : "-"}
                    </h6>
                  </div>
                  <div className="detailPadding d-flex">
                    <i className="fa fa-phone"></i>
                    <h6 className="ms-2">
                      {selectedPatient?.patientProfile?.contactNo
                        ? selectedPatient?.patientProfile?.contactNo
                        : "-"}
                    </h6>
                  </div>
                  <div className="detailPadding d-flex">
                    <i className="fa fa-book"></i>
                    <h6 className="ms-2">
                      {selectedPatient?.patientProfile?.fullName
                        ? selectedPatient?.patientProfile?.fullName
                        : "-"}
                    </h6>
                  </div>
                  <div className="detailPadding d-flex">
                    <i className="fa fa-map-marker"></i>
                    <p className="ms-2">
                      {selectedPatient?.patientProfile?.country &&
                      selectedPatient?.patientProfile?.address
                        ? `${selectedPatient?.patientProfile?.country?.name}, ${selectedPatient?.patientProfile?.address}`
                        : "-"}
                    </p>
                  </div>
                </div> */}

                <Form.Label className="black-label-text mt-2">
                  Patient Medical History
                </Form.Label>
                {patientHistory?.length > 0 &&
                  patientHistory?.map((e, i) => {
                    if (!e.history?.medicalHistory) {
                      return <></>;
                    }
                    return (
                      <div className="accordion-patient">
                        <Accordion defaultActiveKey={"0"}>
                          <Accordion.Item
                            eventKey="0"
                            style={{
                              border: "none",
                              outline: "none",
                            }}
                          >
                            <Accordion.Header>
                              <div className="bold font-14">{e.date}</div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <div>
                                <div>
                                  <div>
                                    <ListGroup.Item
                                      as="li"
                                      className="d-flex justify-content-between align-items-start mb-2 border p-2 rounded"
                                    >
                                      <div className="ms-2 me-auto cursor-pointer">
                                        <div>{e.history?.medicalHistory}</div>
                                      </div>
                                    </ListGroup.Item>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    );
                  })}
                <Form.Label className="black-label-text mt-2">
                  Cosmetic History
                </Form.Label>
                {patientHistory?.length > 0 &&
                  patientHistory?.map((e, i) => {
                    if (!e.history?.cosmeticHistory) {
                      return <></>;
                    }
                    return (
                      <div className="accordion-patient">
                        <Accordion defaultActiveKey={"0"}>
                          <Accordion.Item
                            eventKey="0"
                            style={{
                              border: "none",
                              outline: "none",
                            }}
                          >
                            <Accordion.Header>
                              <div className="bold font-14">{e.date}</div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <div>
                                <div>
                                  <div>
                                    <ListGroup.Item
                                      as="li"
                                      className="d-flex justify-content-between align-items-start mb-2 border p-2 rounded"
                                    >
                                      <div className="ms-2 me-auto cursor-pointer">
                                        <div>{e.history?.cosmeticHistory}</div>
                                      </div>
                                    </ListGroup.Item>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    );
                  })}
                <Form.Label className="black-label-text mt-2">
                  Adverse Cosmetic History
                </Form.Label>

                {patientHistory?.length > 0 &&
                  patientHistory?.map((e, i) => {
                    if (!e.history?.adverseCosmeticHistory) {
                      return <></>;
                    }
                    return (
                      <div className="accordion-patient">
                        <Accordion defaultActiveKey={"0"} key={i}>
                          <Accordion.Item
                            eventKey="0"
                            style={{
                              border: "none",
                              outline: "none",
                            }}
                          >
                            <Accordion.Header>
                              <div className="bold font-14">{e.date}</div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <div>
                                <div>
                                  <div>
                                    <ListGroup.Item
                                      as="li"
                                      className="d-flex justify-content-between align-items-start mb-2 border p-2 rounded"
                                    >
                                      <div className="ms-2 me-auto cursor-pointer">
                                        <div>
                                          {e.history?.adverseCosmeticHistory}
                                        </div>
                                      </div>
                                    </ListGroup.Item>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    );
                  })}
                <Form.Label className="black-label-text mt-2">
                  Social History
                </Form.Label>
                {patientHistory?.length > 0 &&
                  patientHistory?.map((e, i) => {
                    if (!e.history?.socialHistory) {
                      return <></>;
                    }
                    return (
                      <div className="accordion-patient">
                        <Accordion defaultActiveKey={"0"}>
                          <Accordion.Item
                            eventKey="0"
                            style={{
                              border: "none",
                              outline: "none",
                            }}
                          >
                            <Accordion.Header>
                              <div className="bold font-14">{e.date}</div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <div>
                                <div>
                                  <div>
                                    <ListGroup.Item
                                      as="li"
                                      className="d-flex justify-content-between align-items-start mb-2 border p-2 rounded"
                                    >
                                      <div className="ms-2 me-auto cursor-pointer">
                                        <div>{e.history?.socialHistory}</div>
                                      </div>
                                    </ListGroup.Item>
                                  </div>
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </div>
                    );
                  })}
              </div>
            </div>
          </Col>
          <Col lg={9}>
            {" "}
            <div
              style={{
                display:
                  currentState === SESSION_CURRENT_STATE.patientMedicalHistory
                    ? false
                    : "none",
              }}
            >
              <>
                <PatientMedicalHistory
                  setCurrentState={setCurrentState}
                  seddionId={sessionForm.dataId}
                  saveData={saveData}
                  setSaveData={() => setSaveData((v) => v + 1)}
                  getEditData={getEditData}
                  setSuccessSaveData={(success) =>
                    setSuccessSaveData((v) => ({ ...v, mh: success }))
                  }
                />
              </>
            </div>
            <div
              style={{
                display:
                  currentState === SESSION_CURRENT_STATE.patientSOAP
                    ? false
                    : "none",
              }}
            >
              <>
                <PatientSOAP
                  setCurrentState={setCurrentState}
                  saveData={saveData}
                  setSaveData={() => setSaveData((v) => v + 1)}
                  getEditData={getEditData}
                  setSuccessSaveData={(success) =>
                    setSuccessSaveData((v) => ({ ...v, soap: success }))
                  }
                />
              </>
            </div>
            {currentState === SESSION_CURRENT_STATE.patientConsents && (
              <>
                <PatientConsents
                  setCurrentState={setCurrentState}
                  getEditData={getEditData}
                />
              </>
            )}
            {currentState === SESSION_CURRENT_STATE.patientChart && (
              <>
                <PatientChart
                  setCurrentState={setCurrentState}
                  disabled={!isDoctor}
                  seddionId={sessionForm.dataId}
                  getEditData={getEditData}
                />
              </>
            )}
            <div
              style={{
                display:
                  currentState ===
                  SESSION_CURRENT_STATE.patientPrescriptionSheet
                    ? false
                    : "none",
              }}
            >
              <>
                <PatientPrescriptionSheet
                  setCurrentState={setCurrentState}
                  paitentId={sessionForm.patientID}
                  sessionId={sessionForm.dataId}
                  saveData={saveData}
                  setSaveData={() => setSaveData((v) => v + 1)}
                  getEditData={getEditData}
                  setSuccessSaveData={(success) =>
                    setSuccessSaveData((v) => ({ ...v, ps: success }))
                  }
                  patientData={selectedPatient}
                />
              </>
            </div>
            {currentState === SESSION_CURRENT_STATE.patientCaseFolder && (
              <div style={{ paddingRight: "25px" }}>
                <PatientCaseFolder
                  setCurrentState={setCurrentState}
                  getEditData={getEditData}
                />
              </div>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
}
